<template>
<div class="mktops-maincontent-create maincontent-create-3">
    <div :class="(loadData == true) ? 'bg-backdrop-promotion-loading' : ''"></div>
    <div :class="(loadDialog == true) ? 'bg-backdrop-promotion' : ''"></div>
    <div style="position: absolute;top: 50%; left: 50%; width: 10%; z-index: 20;" v-show="loadData == true">
        <md-progress-spinner :md-stroke="8" :md-diameter="65" md-mode="indeterminate"></md-progress-spinner>
    </div>

    <div class="mktops-mainheader-text md-layout-item md-size-100">
        <label class="tab-title create">create a promotion</label>
    </div>
    <div class="md-gutter mktops-stepper">
        <md-card class="main-content">
            <div class="step-content mktops-step3-flex">
                <div class="header-step">
                    <md-avatar class="md-avatar-icon step-content-num">3</md-avatar>
                    <span class="card-title">Create Condition Sets</span>
                </div>
                <div class="mktops-flex-end-center">
                    <md-menu md-size="medium" md-align-trigger>
                        <md-button class="md-dense md-raised md-primary mktops-add-condition-btn" md-menu-trigger>
                            <span class="add-condition-symbol">+</span>
                            <span class="add-condition-text">ADD CONDITION SET</span>
                        </md-button>
                        <md-menu-content>
                            <md-menu-item @click="set_new(-1, sets.length)">NEW</md-menu-item>
                            <!-- <md-menu-item v-for="(item , index) in sets" @click="set_new(index)" :key="`menu_${index}`">Duplicate SET {{(index+1)}}</md-menu-item> -->
                            <md-menu-item v-for="(item , index) in sets" @click="set_new(index)" :key="`menu_${index}`">Duplicate SET {{ item.name.toUpperCase() }}</md-menu-item>
                        </md-menu-content>
                    </md-menu>
                </div>
            </div>
            <div class="data-input-step">
                <div class="md-layout">
                    <div class="md-layout-item md-size-100">
                        <md-card-content>
                            <div>
                                <md-tabs ref="reftab"  @md-changed="checkSelectTab" :md-active-tab="(this.selectTab)?this.selectTab:''">
                                    <!-- <md-tab v-for="(item , index) in sets" v-bind:key="index" :id="`tab-${index}`" :md-label="`SET ${(index+1)}`" @click="onsetIndex(index)"> -->
                                    <md-tab v-for="(item , index) in sets" v-bind:key="index" :id="`tab-${index}`" @click="onsetIndex(index)" :md-label="(item.name == '') ? `SET ${(index+1)}` : `${item.name}`">
                                        <div class="md-layout-item md-layout md-gutter">
                                            <div class="md-layout-item md-size-64">
                                                <div class="md-layout md-gutter md-layout-item md-size-100">
                                                    <div class="md-layout-item md-size-45 mktops-label-focus">
                                                        <md-field md-inline>
                                                            <label>SET {{index+1}}</label>
                                                            <md-input v-model="item.name"></md-input>
                                                        </md-field>
                                                    </div>
                                                    <div class="md-layout-item md-size-45">
                                                        <md-field>
                                                            <md-select placeholder="Default Price" v-model="item.default_price">
                                                                <!-- START Change 09.05.2019 -->
                                                                <!-- <md-option class="latofont" v-for="item in defailtPrice" :key="item.code" :value="item.code">{{item.code}}:{{item.title}}</md-option> -->
                                                                <md-option class="latofont" v-for="code in defailtPrice" :key="code" :value="code">{{code}}</md-option>
                                                                    <!-- END Change 09.05.2019 -->
                                                            </md-select>
                                                        </md-field>
                                                    </div>

                                                    <div class="md-layout-item md-size-10">
                                                        <div class="mktops-btn-close">
                                                            <md-menu md-size="medium" :md-offset-x="127" :md-offset-y="-36">
                                                                <md-button class="md-icon-button mktops-float-right" md-menu-trigger style="margin-left: 25px;">
                                                                    <md-icon>more_vert</md-icon>
                                                                </md-button>
                                                                <md-menu-content>
                                                                    <md-menu-item class="latofont" @click="set_new(index)">
                                                                        <span style="color: #000000;">Duplicate</span>
                                                                    </md-menu-item>
                                                                    <md-menu-item class="latofont" @click="set_reset(index)">
                                                                        <span style="color: #000000;">Reset</span>
                                                                    </md-menu-item>
                                                                    <md-menu-item class="latofont" v-if="sets.length > 1 && index != 0" @click="set_delete(index)">
                                                                        <span style="color: #000000;">Delete</span>
                                                                    </md-menu-item>
                                                                    <md-menu-item class="latofont" v-else>
                                                                        <span>Delete</span>
                                                                    </md-menu-item>
                                                                </md-menu-content>
                                                            </md-menu>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="mktops-step3-flex md-size-100">
                                                    <div class="mktops-flex-center">
                                                        <label class="mktops-text-condition">Set your Conditions</label>
                                                    </div>
                                                    <div>
                                                        <md-menu md-size="medium" :md-offset-x="127" :md-offset-y="-36">
                                                            <md-button class="md-primary" md-menu-trigger style="margin-left: 25px;">+ SELECT A CONDITION</md-button>
                                                            <!--<md-checkbox title="เพื่อระบุการคำนวณ Condition แบบคละ Item ในการเปิด Order สั่งซื้อชุดนั้นๆ" v-model="item.mix_set" style="margin-bottom: 0px; margin-top: 9px; margin-left: 15px;">Mix set</md-checkbox>-->
                                                            <div v-if="item.conditions.length >= 4" />
                                                            <div v-else>
                                                                <md-menu-content>
                                                                    <md-menu-item v-for="(menucondition,menucondition_index) in menuConditions" v-if="checkShowMenu(item.conditions,menucondition)" :disabled="checkShowMenuDisabled(item.conditions,menucondition)" :key="menucondition_index" @click="condition_new(index,menucondition)">
                                                                        <span>{{menucondition}}</span>
                                                                    </md-menu-item>
                                                                </md-menu-content>
                                                            </div>
                                                        </md-menu>
                                                    </div>
                                                </div>
                                                <div class="mktops-notice-notdata" v-if="item.conditions.length == 0">No set Conditions. Add condition(s) to this set</div>
                                                <div class v-for="(item_condition , index_condition) in item.conditions" :key="`condition_${index}_${index_condition}`">
                                                    <div class="md-layout md-gutter md-layout-item md-size-100">
                                                        <div class="mktops-line"></div>
                                                        <!-- <div class="mktops-flex-center md-layout-item md-size-25" style="padding-right: 0px;"> -->
                                                        <div v-if="(item_condition.type == 'Count Item' || item_condition.type == 'Count Value' || item_condition.type == 'Count Mix')" class="mktops-flex-center md-layout-item" style="max-width: 25%; padding-right: 0px;">
                                                            <span class="mktops-text-qty">Count Item (≥)</span>
                                                        </div>
                                                        <div v-else class="mktops-flex-center md-layout-item" style="max-width: 21%; padding-right: 0px;">
                                                            <span class="mktops-text-qty">{{item_condition.type}}</span>
                                                        </div>

                                                        <div v-if="(item_condition.type == 'Count Item' || item_condition.type == 'Count Value' || item_condition.type == 'Count Mix')" class="md-layout-item md-size-20 mktops-label-focus" style="padding-left: 5px; padding-right: 5px;">
                                                            <md-field md-inline>
                                                                <md-input type="number" min="0" placeholder="Count" v-model="item_condition.count" @change="changeConditions(index,'min')"></md-input>
                                                            </md-field>
                                                        </div>

                                                        <!-- START NOT Count Item (≥) -->
                                                        <div v-if="(item_condition.type != 'Count Item' && item_condition.type != 'Count Value' && item_condition.type != 'Count Mix')" class="md-layout-item md-size-15 mktops-label-focus" style="padding-left: 5px; padding-right: 5px;">
                                                            <md-field md-inline>
                                                                <md-input type="number" min="0" placeholder="Min" v-model="item_condition.min" @change="changeConditions(index,'min')"></md-input>
                                                            </md-field>
                                                        </div>
                                                        <div :class="(item_condition.type != 'Count Item' && item_condition.type != 'Count Value' && item_condition.type != 'Count Mix') ? 'md-layout-item md-size-15 mktops-label-focus' : 'md-layout-item md-size-10 mktops-label-focus'" style="padding-left: 5px; padding-right: 5px;">
                                                            <md-field v-if="(item_condition.type != 'Count Item' && item_condition.type != 'Count Value' && item_condition.type != 'Count Mix')" md-inline>
                                                                <md-input type="number" min="0" placeholder="Max" :disabled="item_condition.maxdis" v-model="item_condition.max" @change="changeConditions(index,'max')"></md-input>
                                                            </md-field>
                                                        </div>
                                                        <!-- <div class="md-layout-item md-size-25"> -->
                                                        <!-- <div class="md-layout-item" style="max-width: 29%;"> -->
                                                        <div class="md-layout-item" v-bind:style="item_condition.type != 'Count Item' && item_condition.type != 'Count Value' && item_condition.type != 'Count Mix' ? {'max-width': '29%'} : {'max-width': '25%'}">
                                                            <md-checkbox v-if="(item_condition.type != 'Count Item' && item_condition.type != 'Count Value' && item_condition.type != 'Count Mix')" style="margin-top: 30px; margin-right: 0px;" v-model="item_condition.max_level" @change="changeConditions(index,'max_level')">Max level</md-checkbox>
                                                        </div>
                                                        <div class="md-layout-item md-size-10">
                                                            <div class="mktops-btn-close">
                                                                <md-button @click="condition_delete(index,index_condition)" class="md-icon-button mktops-float-right">
                                                                    <md-icon>close</md-icon>
                                                                </md-button>
                                                            </div>
                                                        </div>
                                                        <!-- END NOT Count Item (≥) -->
                                                    </div>
                                                    
                                                    <!-- START Count Item (≥) && Count Value -->
                                                    <div v-if="(item_condition.type == 'Count Item' || item_condition.type == 'Count Value')" class="md-layout md-gutter md-layout-item md-size-100" style="height: 50px; margin-bottom: 15px;">
                                                        <div class="sub-qty"></div>
                                                        <div class="mktops-flex-center md-layout-item" style="max-width: 25%; padding-right: 10px; justify-content: flex-end; height: 30px;">
                                                            <span v-if="item_condition.type == 'Count Item'" class="mktops-text-qty">QTY</span>
                                                            <span v-if="item_condition.type == 'Count Value'" class="mktops-text-qty">Value</span>
                                                        </div>
                                                        <div class="md-layout-item md-size-15 mktops-label-focus" style="padding-left: 5px; padding-right: 5px;">
                                                            <md-field md-inline style="padding-top: 0px; margin-top: 0px; min-height: 25px;">
                                                                <md-input type="number" min="0" placeholder="Min" v-model="item_condition.min" @change="changeConditions(index,'min')"></md-input>
                                                            </md-field>
                                                        </div>
                                                        <div class="md-layout-item md-size-15 mktops-label-focus" style="padding-left: 5px; padding-right: 5px;">
                                                            <md-field md-inline style="padding-top: 0px; margin-top: 0px; min-height: 25px;">
                                                                <md-input type="number" min="0" placeholder="Max" :disabled="item_condition.maxdis" v-model="item_condition.max" @change="changeConditions(index,'max')"></md-input>
                                                            </md-field>
                                                        </div>
                                                        <div class="md-layout-item" style="max-width: 29%;">
                                                            <md-checkbox style="margin-top: 12px; margin-right: 0px;" v-model="item_condition.max_level" @change="changeConditions(index,'max_level')">Max level</md-checkbox>
                                                        </div>
                                                    </div>
                                                    <!-- END Count Item (≥) && Count Value -->

                                                    <!-- START Count Mix (≥) -->
                                                    <div v-if="item_condition.type == 'Count Mix'" class="md-layout md-gutter md-layout-item md-size-100" style="height: 50px; margin-bottom: 10px;">
                                                        <div class="sub-qty"></div>
                                                        <div class="mktops-flex-center md-layout-item" style="max-width: 25%; padding-right: 10px; justify-content: flex-end; height: 30px;">
                                                            <span class="mktops-text-qty">QTY</span>
                                                        </div>
                                                        <div class="md-layout-item md-size-15 mktops-label-focus" style="padding-left: 5px; padding-right: 5px;">
                                                            <md-field md-inline style="padding-top: 0px; margin-top: 0px; min-height: 25px;">
                                                                <md-input type="number" min="0" placeholder="Min" v-model="item_condition.min" @change="changeConditions(index,'min')"></md-input>
                                                            </md-field>
                                                        </div>
                                                        <div class="md-layout-item md-size-15 mktops-label-focus" style="padding-left: 5px; padding-right: 5px;">
                                                            <md-field md-inline style="padding-top: 0px; margin-top: 0px; min-height: 25px;">
                                                                <md-input type="number" min="0" placeholder="Max" :disabled="item_condition.maxdis" v-model="item_condition.max" @change="changeConditions(index,'max')"></md-input>
                                                            </md-field>
                                                        </div>
                                                        <div class="md-layout-item" style="max-width: 29%;">
                                                            <md-checkbox style="margin-top: 12px; margin-right: 0px;" v-model="item_condition.max_level" @change="changeConditions(index,'max_level')">Max level</md-checkbox>
                                                        </div>
                                                    </div>
                                                    <div v-if="item_condition.type == 'Count Mix'" class="md-layout md-gutter md-layout-item md-size-100" style="height: 50px; margin-bottom: 15px;">
                                                        <div class="sub-qty"></div>
                                                        <div class="mktops-flex-center md-layout-item" style="max-width: 25%; padding-right: 10px; justify-content: flex-end; height: 30px;">
                                                            <span class="mktops-text-qty">Value</span>
                                                        </div>
                                                        <div class="md-layout-item md-size-15 mktops-label-focus" style="padding-left: 5px; padding-right: 5px;">
                                                            <md-field md-inline style="padding-top: 0px; margin-top: 0px; min-height: 25px;">
                                                                <md-input type="number" min="0" placeholder="Min" v-model="item_condition.min_value" @change="changeConditions(index,'min_value')"></md-input>
                                                            </md-field>
                                                        </div>
                                                        <div class="md-layout-item md-size-15 mktops-label-focus" style="padding-left: 5px; padding-right: 5px;">
                                                            <md-field md-inline style="padding-top: 0px; margin-top: 0px; min-height: 25px;">
                                                                <md-input type="number" min="0" placeholder="Max" :disabled="item_condition.maxdis_value" v-model="item_condition.max_value" @change="changeConditions(index,'max_value')"></md-input>
                                                            </md-field>
                                                        </div>
                                                        <div class="md-layout-item" style="max-width: 29%;">
                                                            <md-checkbox style="margin-top: 12px; margin-right: 0px;" v-model="item_condition.max_value_level" @change="changeConditions(index,'max_value_level')">Max level</md-checkbox>
                                                        </div>
                                                    </div>
                                                    <!-- END Count Mix (≥) -->
                                                </div>
                                                <div class="mktops-step3-flex md-size-100">
                                                    <div class="mktops-flex-center">
                                                        <span class="mktops-text-promotion">Set your Promotion</span>
                                                    </div>
                                                    <div>
                                                        <md-menu md-size="medium" :md-offset-x="127" :md-offset-y="-36">
                                                            <md-button class="md-primary" md-menu-trigger style="margin-left: 25px;">+ SELECT A PROMOTION</md-button>
                                                            <div v-if="item.promotions.length >= 4" />
                                                            <div v-else>
                                                                <md-menu-content>
                                                                    <md-menu-item v-for="(menupromotion,menupromotion_index) in menuPromotions" v-if="checkShowMenu(item.promotions,menupromotion)" :key="menupromotion_index" @click="promotion_new(index,menupromotion)">
                                                                        <span v-if="menupromotion == 'Discount'">{{menupromotion}} %</span>
                                                                        <span v-else>{{menupromotion}}</span>
                                                                    </md-menu-item>
                                                                </md-menu-content>
                                                            </div>
                                                        </md-menu>
                                                    </div>
                                                </div>
                                                <div class="mktops-notice-notdata" v-if="item.promotions.length == 0">No set Promotions. Add promotion(s) to this set</div>
                                                <div v-for="(item_promotion , index_promotion) in item.promotions" :key="`promotion_${index}_${index_promotion}`" :class="item_promotion.vclass">
                                                    <template v-if="item_promotion.type == 'Discount'">
                                                        <div class="md-layout md-gutter md-layout-item md-size-100">
                                                            <div class="mktops-line"></div>
                                                            <div class="mktops-flex-center md-layout-item" style="padding-right: unset; max-width: 21%;">
                                                                <span class="mktops-text-qty">Discount</span>
                                                            </div>
                                                            <div class="md-layout-item mktops-label-focus" style="padding-right: unset; padding-left: 5px; max-width: 59%;">
                                                                <md-field md-inline style="width: 48%;">
                                                                    <md-input type="number" v-model="item_promotion.value" min="0" max="100" @change="changePromotion(index,'Discount')" placeholder="Percent" on />
                                                                    <span class="md-suffix" style="color:#000;">%</span>
                                                                </md-field>
                                                            </div>
                                                            <div class="md-layout-item md-size-10">
                                                                <div class="mktops-btn-close">
                                                                    <md-button @click="promotion_delete(index,index_promotion)" class="md-icon-button mktops-float-right">
                                                                        <md-icon>close</md-icon>
                                                                    </md-button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </template>

                                                    <template v-else-if="item_promotion.type == 'Free item'">
                                                        <div class="md-layout md-gutter md-layout-item md-size-100">
                                                            <div class="mktops-line"></div>
                                                            <div class="mktops-flex-center md-layout-item" style="padding-right: unset; max-width: 21%;">
                                                                <span class="mktops-text-qty" style="margin: 25px 0px 24px;">Free item</span>
                                                            </div>
                                                            <!-- <div class="md-layout-item mktops-label-focus" style="padding-right: unset;margin: 34px 0 24px;padding-top: 16px;display: flex; max-width: 59%;"> -->
                                                            <div class="md-layout-item mktops-label-focus" style="padding-right: unset; margin: 25px 0 24px; display: flex; max-width: 59%;">
                                                                <!-- <md-field md-inline><md-input type="number" v-model="item_promotion.value" min="0" placeholder="Item code"/></md-field>-->
                                                                <div v-show="(item_promotion.number_of_item_flag == true)" class="number-of-items">Pick up &ensp; {{ (item_promotion.number_of_item == '') ? '-' : item_promotion.number_of_item }} &ensp; item from all list</div>
                                                                <div v-show="(item_promotion.ratio_flage == true)" class="number-of-items">Ratio &ensp; {{ (item_promotion.ratio !== undefined) ? item_promotion.ratio[0] + ' : ' + item_promotion.ratio[1] : '' }}</div>
                                                            </div>
                                                            <!-- <div class="md-layout-item md-size-60">
                                                                <div class="mktops-btn-close">
                                                                    <div class="number-of-items">Number of &ensp; {{ (item_promotion.number_of_item == '') ? '-' : item_promotion.number_of_item }} &ensp; items</div>
                                                                    <md-button @click="promotion_showDialog(index,index_promotion)" class="md-icon-button mktops-float-right">
                                                                        <md-icon>edit</md-icon>
                                                                    </md-button>
                                                                    <md-button @click="promotion_delete(index,index_promotion)" class="md-icon-button mktops-float-right">
                                                                        <md-icon>close</md-icon>
                                                                    </md-button>
                                                                </div>
                                                            </div> -->
                                                            <div class="md-layout-item md-size-30">
                                                                <div class="mktops-btn-close">
                                                                    <md-button @click="promotion_showDialog(index,index_promotion)" class="md-icon-button mktops-float-right">
                                                                        <md-icon>edit</md-icon>
                                                                    </md-button>
                                                                    <md-button @click="promotion_delete(index,index_promotion)" class="md-icon-button mktops-float-right">
                                                                        <md-icon>close</md-icon>
                                                                    </md-button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="md-layout md-gutter md-layout-item md-size-100" v-if="item_promotion.value.length === 0" style="margin-top: calc(30vh - 160px);">
                                                            <div class="md-layout-item md-size-10"></div>
                                                            <div class="md-layout-item md-size-80" style="text-align: center;">
                                                                <span style="font-size: 16px;color:#A8A8A8;">Click<md-icon style="color:#A8A8A8;">edit</md-icon>Add Free item (or Edit Free item)</span>
                                                            </div>
                                                            <div class="md-layout-item md-size-10"></div>
                                                        </div>
                                                        <!-- <div class="number-of-items">
                                                            Number of &ensp;
                                                            <input type="text" v-model="item_promotion.number_of_item" class="disabled-input" :disabled="true">
                                                            &ensp; items
                                                        </div> -->
                                                        <div class="md-layout" v-if="item_promotion.value.length > 0">
                                                            <div class="md-layout md-gutter md-layout-item md-size-100">
                                                                <div id="table-freeitem-scroll">
                                                                    <div id="divHeadFreeitem">
                                                                        <div style="width: 15%;">Code</div>
                                                                        <div style="width: 55%;">Description</div>
                                                                        <div style="width: 15%;text-align: center;">Unit</div>
                                                                        <div style="width: 15%;text-align: right;">QTY</div>
                                                                        <!-- <div style="width: 15%;text-align: center;">Ratio</div> -->
                                                                    </div>
                                                                    <div id="divBodyFreeitem">
                                                                        <div :class="(item_free.status == 'Inactive') ? '-inactive-product row' : 'row'" v-for="(item_free , index_free) in item_promotion.value" :key="`promotion_${index}_${index_free}`">
                                                                            <div style="width: 15%;">{{item_free.code}}</div>
                                                                            <div style="width: 55%;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">
                                                                                <span :title="item_free.desc">{{ item_free.desc }}</span>
                                                                            </div>
                                                                            <div style="width: 15%;text-align: center;">{{item_free.unit}}</div>
                                                                            <div style="width: 15%;text-align: right;">{{item_free.qty != '' ? item_free.qty:'-'}}</div>
                                                                            <!-- <div style="width: 15%;text-align: center;">{{item_free.ratio[0] != '' ? item_free.ratio[0]+':'+item_free.ratio[1] : '-'}}</div> -->
                                                                        </div>
                                                                    </div>
                                                                    <div style="display: flex; font-weight: 400; font-size: 13px; font-style: italic; margin-top: 10px;">
                                                                        <div style="width: 55%; color: red;">*Product code ที่ถูก Inactive</div>
                                                                        <div style="width: 45%;">number of product ({{item_promotion.value.length}})</div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <!-- START DIALOG FREE ITEM -->
                                                        <md-dialog id="md-dialog-freeitem" :md-active.sync="showDialog" style="max-height: unset;" :md-click-outside-to-close="clickOutside">
                                                            <md-dialog-title style="background: #FFF;">
                                                                <label style="line-height: 40px;color:#000;font-weight: 500;font-family:Roboto">Free item</label>
                                                            </md-dialog-title>

                                                            <!-- <div class="md-layout md-gutter" style="margin-bottom: 10px;">
                                                                <div class="md-layout-item md-size-20" style="padding-left: 71px; padding-top: 8px; padding-right: unset;">
                                                                    <span class="span-item">Number of</span>
                                                                </div>
                                                                <div class="md-layout-item md-size-15" style="padding-left: unset;">
                                                                    <div class="filter-table">
                                                                        <input type="text" placeholder="Number" v-model="temp_pm_set.number_of_item" @keypress="isNumber" :class="(!temp_pm_set.number_of_item_flag) ? 'disabled-input' : ''" :disabled="!temp_pm_set.number_of_item_flag">
                                                                    </div>
                                                                </div>
                                                                <div class="md-layout-item md-size-5" style="padding-top: 8px; padding-right: unset;">
                                                                    <span class="span-item">items</span>
                                                                </div>
                                                                <div class="md-layout-item md-size-55">
                                                                    <md-checkbox class="md-primary" title="เลือกเมื่อต้องการกรอกค่า Number of items" v-model="temp_pm_set.number_of_item_flag" style="margin-bottom: 0px; margin-top: 9px; margin-left: 15px;"></md-checkbox>
                                                                </div>
                                                            </div> -->

                                                            <!-- START NEW REQUIREMENT : 22.08.2019 -->
                                                            <div class="md-layout md-gutter" style="margin-top: 5px; margin-bottom: 15px;">
                                                                <div class="md-layout-item md-size-20" style="padding-left: 71px; padding-top: 10px; padding-right: unset;">
                                                                    <span class="span-item">Condition</span>
                                                                </div>
                                                                <div class="md-layout-item md-size-15 select-condotion-item">
                                                                    <md-field class="box">
                                                                        <md-select v-model="selectedCondition" id="select-price-unit">
                                                                            <md-option v-for="(itemSlc, index) in itemCondition" :key="index" :value="index">{{itemSlc}}</md-option>
                                                                        </md-select>
                                                                    </md-field>
                                                                </div>

                                                                <!-- PICK UP -->
                                                                <div v-show="(selectedCondition == 1)" class="md-layout-item md-size-10" style="padding-left: unset; padding-right: 0px;">
                                                                    <div class="filter-table">
                                                                        <input type="text" placeholder="Number" v-model="temp_pm_set.number_of_item" @keypress="isNumber" style="text-align: right;">
                                                                    </div>
                                                                </div>
                                                                <div v-show="(selectedCondition == 1)" class="md-layout-item md-size-50" style="padding-top: 8px; padding-right: unset; padding-left: 15px;">
                                                                    <span class="span-item">item from all list</span>
                                                                </div>

                                                                <!-- RATIO -->
                                                                <div v-show="(selectedCondition == 2)" class="md-layout-item md-size-10" style="padding-right: 5px; padding-left: 5px;">
                                                                    <div class="filter-table">
                                                                        <input type="text" placeholder="Number" v-model="temp_pm_set.ratio0_of_item" @keypress="isNumber" style="text-align: right;">
                                                                    </div>
                                                                </div>
                                                                <span v-show="(selectedCondition == 2)" style="    padding-top: 6px; margin-left: 3px; margin-right: 3px;"> : </span>
                                                                <div v-show="(selectedCondition == 2)" class="md-layout-item md-size-10" style="padding-right: 5px; padding-left: 5px;">
                                                                    <div class="filter-table">
                                                                        <input type="text" placeholder="Number" v-model="temp_pm_set.ratio1_of_item" @keypress="isNumber" style="text-align: right;">
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <!-- END NEW REQUIREMENT : 22.08.2019 -->
                                                            
                                                            <div class="md-layout md-gutter">
                                                                <div class="md-layout-item md-size-20" style="padding-left: 71px;padding-top: 8px;padding-right: unset;">
                                                                    <span class="span-item">ITEMS IN GROUP</span>
                                                                </div>

                                                                <div class="md-layout-item md-size-40" style="padding-left: unset;">
                                                                    <div class="mktops-control-box" style="display: flex;">
                                                                        <treeselect ref="productSearchTxt" class="treeview-box" :multiple="true" :limit="1" :maxHeight="400" placeholder="+ Add with Product Code" :async="true" :load-options="loadOptions" :cache-options="false" v-model="valueTree" :value-consists-of="valueConsistsOf" :clearable="false" @select="openOnSelectTreeview" @deselect="onDeSelectTreeview" />
                                                                        <i class="material-icons" title="Search by product name" style="margin-top: 6px; margin-left: 13px; cursor: pointer; color: rgb(168, 168, 168);" @click="onClickDialogFilter()">filter_list</i>
                                                                    </div>
                                                                </div>

                                                                <div class="md-layout-item md-size-30" style="padding-right: 0px;">
                                                                    <div class="filter-table">
                                                                        <input type="text" placeholder="Filter" @input="searchOnTable" v-model="search">
                                                                    </div>
                                                                </div>

                                                                <div class="md-layout-item md-size-10" style="padding-left: 0px;">
                                                                    <md-button refs="btndelete" class="md-icon-button md-primary" @click="deleteProduct">
                                                                        <md-icon class="md-theme-primary" v-bind:style="checkedProducts.length === 0 ? {color: '#A8A8A8'} : {color: '#3F51B5'}">delete_sweep</md-icon>
                                                                    </md-button>
                                                                </div>
                                                            </div>

                                                            <div class="md-layout md-gutter md-layout-item md-size-100" v-if="temp_freeitem.length === 0" style="margin-top: calc(50vh - 160px);">
                                                                <div class="md-layout-item md-size-10"></div>
                                                                <div class="md-layout-item md-size-80" style="text-align: center;">
                                                                    <span style="font-size: 16px;color:#A8A8A8;" >Select products by adding by product code</span>
                                                                </div>
                                                                <div class="md-layout-item md-size-10"></div>
                                                            </div>

                                                            <div class="md-layout md-gutter" v-if="temp_freeitem.length > 0">
                                                                <div class="md-layout-item md-large-size-100 md-medium-size-100 md-small-size-100">
                                                                    <div id="dialogtable-freeitem-scroll">
                                                                        <div id="dialogHeadFreeitem">
                                                                            <div style="width: 5%;">
                                                                                <label class="checkbox-container">
                                                                                <input type="checkbox" @click="selectAll" v-model="checkedProductsAll"><span class="-checkbox-primary"></span></label>
                                                                            </div>
                                                                            <div style="width: 10%;">Code</div>
                                                                            <div style="width: 50%;">Name</div>
                                                                            <div style="width: 15%;text-align: center;">Unit</div>
                                                                            <div style="width: 20%;text-align: center;">QTY</div>
                                                                            <!-- <div style="width: 15%;text-align: center;padding-right: 15px;">Ratio</div> -->
                                                                        </div>
                                                                        <div id="dialogBodyFreeitem">
                                                                            <div :class="(item_free.status == 'Inactive') ? '-inactive-product row' : 'row'" v-for="(item_free , index_free) in temp_freeitem" :key="`promotion_${index}_${index_free}`" v-show="item_free.display">
                                                                                <div style="width: 5%;">
                                                                                    <label class="checkbox-container">
                                                                                    <input type="checkbox" v-model="checkedProducts" :id="item_free.code" :value="item_free"><span class="-checkbox-primary"></span></label>
                                                                                </div>
                                                                                <div style="width: 10%;">{{item_free.code}}</div>
                                                                                <div style="width: 50%;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">
                                                                                    <span :title="item_free.desc">{{ item_free.desc }}</span>
                                                                                </div>
                                                                                <div style="width: 15%;text-align: center;">{{item_free.unit}}</div>
                                                                                <div style="width: 20%;text-align: center;">
                                                                                    <div class="qty-table">
                                                                                        <!-- <input type="number" :class="(item_promotion.number_of_item_flag) ? 'disabled-input' : ''" min="0" v-bind:style="{ background: item_free.ck_qty,textAlign:'right'}" :disabled="item_free.ck_qty == '#efefef'" @change="ckConditions(item_free,'qty')" v-model="item_free.qty"></div> -->
                                                                                        <!-- <input type="number" :class="(temp_pm_set.number_of_item_flag || item_free.status == 'Inactive') ? 'disabled-input' : ''" min="0" v-bind:style="{ background: item_free.ck_qty,textAlign:'right'}" :disabled="disabledInput(item_free, item_free.ck_qty)" @change="ckConditions(item_free,'qty')" v-model="item_free.qty"></div> -->
                                                                                        <input type="number" :class="(selectedCondition != 0 || item_free.status == 'Inactive') ? 'disabled-input' : ''" min="0" v-bind:style="{ background: item_free.ck_qty,textAlign:'right'}" :disabled="disabledInput(item_free, item_free.ck_qty)" v-model="item_free.qty"></div>
                                                                                    </div>
                                                                                    <!-- <div style="width: 15%;text-align: center;">
                                                                                        <div class="md-layout">
                                                                                            <div class="md-layout-item ratio-table">
                                                                                                <input type="number" min="0" :class="(temp_pm_set.number_of_item_flag || item_free.status == 'Inactive') ? 'disabled-input' : ''" v-bind:style="{ background: item_free.ck_ratio,textAlign:'right'}" :disabled="disabledInput(item_free, item_free.ck_ratio)" @change="ckConditions(item_free,'ratio')" v-model="item_free.ratio[0]"></div>
                                                                                                <div class="md-layout-item">:</div>
                                                                                                <div class="md-layout-item ratio-table">
                                                                                                    <input type="number" min="0" :class="(temp_pm_set.number_of_item_flag || item_free.status == 'Inactive') ? 'disabled-input' : ''" v-bind:style="{ background: item_free.ck_ratio,textAlign:'right'}" :disabled="disabledInput(item_free, item_free.ck_ratio)" @change="ckConditions(item_free,'ratio')" v-model="item_free.ratio[1]"></div>
                                                                                                </div>
                                                                                            </div> -->
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                            <md-dialog-actions>
                                                                                <div style="width: 25%;"></div>
                                                                                <div style="width: 50%; text-align: center; font-weight: 400; font-size: 13px; font-style: italic;">number of product ({{temp_freeitem.length}})</div>
                                                                                <div style="width: 25%; text-align: right;">
                                                                                    <md-button @click="onClosedialog">Cancel</md-button>
                                                                                    <!-- <md-button style="color:#3F51B5;" @click="onSavedialog(index,index_promotion)">Confirm</md-button> -->
                                                                                    <md-button style="color:#3F51B5;" @click="onSavedialog(index, index_promotion, item_promotion)">Confirm</md-button>
                                                                                </div>
                                                                            </md-dialog-actions>
                                                        </md-dialog>
                                                        <!-- END DIALOG FREE ITEM -->

                                                    </template>
                                                    <template v-else-if="item_promotion.type == 'Net Price'">
                                                        <div class="md-layout md-gutter md-layout-item md-size-100">
                                                            <div class="mktops-line"></div>
                                                            <div class="mktops-flex-center md-layout-item" style="padding-right: unset; max-width: 21%;">
                                                                <span class="mktops-text-qty">Net Price</span>
                                                            </div>
                                                            <div class="md-layout-item mktops-label-focus" style="padding-right: unset; padding-left: 5px; max-width: 59%;">
                                                                <md-field md-inline style="width: 48%;">
                                                                    <md-input type="number" v-model="item_promotion.value" min="0" @change="changePromotion(index,'Net Price')" placeholder="Baht" />
                                                                </md-field>
                                                            </div>
                                                            <div class="md-layout-item md-size-10">
                                                                <div class="mktops-btn-close">
                                                                    <md-button @click="promotion_delete(index,index_promotion)" class="md-icon-button mktops-float-right">
                                                                        <md-icon>close</md-icon>
                                                                    </md-button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </template>
                                                </div>
                                            </div>
                                            <div style="background-color:#EFEFEF; width:1px;" />
                                            <div class="md-layout-item md-size-35" style="padding-left: 20px;">
                                                <div style="font-family: Roboto; font-weight: 500; font-size: 16px; color: #000000;">Select Customer</div>
                                                <div  style="margin-top: 8px;max-width: 237px;">
                                                    <div>
                                                        <multiselect @select="onCustomerGroupClick(index)" v-model="customer[index]" @input="customer_new(index)" placeholder="search" :hide-selected="true" :multiple="true" :options="dataOption" label="group_name" track-by="_id" @close="onTouch(index)" :select-label="''" :deselect-label="''" :selected-label="''" >
                                                            <template slot="placeholder"><span class="label_notselect">+ ADD A CUSTOMER GROUP</span></template>
                                                            <template slot="tag" slot-scope="{ option }">
                                                                <span class="multiselect__single promo-step-3">+ ADD A CUSTOMER GROUP</span>
                                                            </template>
                                                        </multiselect>
                                                    </div>
                                                </div>
                                                <!--

<md-button class="md-primary">+ ADD A CUSTOMER GROUP</md-button>

                          -->
                                                <div :id="'div_result_'+index" style="margin-top: 8px;">
                                                    <div style="display: inline-grid;width: calc(100% - 10px);">
                                                        <md-chip class="md-primary" style="margin-top: 8px; margin-left: 0px;" md-deletable v-for="(item_customer , index_customer) in item.customers" :key="'customer_'+index_customer" @md-delete="customer_delete(index,index_customer)">{{ item_customer.group_name }}</md-chip>
                                                    </div>
                                                </div>
                                                <!--

<div style="margin-top: 6px;">

<md-chip class="md-primary" md-deletable>(2) ลูกค้าเขตต่างจังหวัด</md-chip>

</div>

                          -->
                                            </div>
                                        </div>
                                    </md-tab>
                                </md-tabs>
                            </div>
                        </md-card-content>
                    </div>
                </div>
            </div>
            <md-card-actions class="mktops-action-button">
                <md-button class="mktops-button-back-next" @click="nextStep('step-2')">back</md-button>
                <md-button class="mktops-button-back-next md-primary" @click="showDialogsave('Draft')">save</md-button>
            </md-card-actions>
            <md-dialog-alert :md-active.sync="alertshow" md-title="Alert!" :md-content="alertcontent" />
            <md-dialog-alert :md-active.sync="alertCondition" md-title="Alert!" :md-content="alertConditionContent" />
            <md-dialog-confirm :md-active.sync="alertconfirm" md-title="Confirm" md-content="Are you sure to delete?" md-confirm-text="Sure" md-cancel-text="Cancel" @md-cancel="onCancelDelete" @md-confirm="onConfirmDelete" :disabled="saveDisabled" />
            <md-dialog-confirm :md-active.sync="active" md-title="Confirm" md-content="Are you sure to save ?" md-confirm-text="Sure" md-cancel-text="Cancel" @md-cancel="onCancel" @md-confirm="onConfirm" :disabled="saveDisabled" />
            <md-dialog-confirm :md-active.sync="activeMaxValue" md-title="Are you sure to save ?" :md-content="dialog_title_max" md-confirm-text="Sure" md-cancel-text="Cancel" @md-cancel="onCancel" @md-confirm="onConfirm" :disabled="saveDisabled" />
        </md-card>

        <md-snackbar :md-position="position" :md-duration="isInfinity ? Infinity : duration" :md-active.sync="showSnackbar" md-persistent>
            <span>{{ dContent }}</span>
            <md-button class="md-primary" @click="showSnackbar = false">OK</md-button>
        </md-snackbar>
        <stepper></stepper>

        <md-dialog :md-active.sync="showDialogComment" class="promo-memo" :md-click-outside-to-close="false">
            <md-dialog-title>Please enter the reason.</md-dialog-title>

            <div class="layout-dialog">
                <textarea v-model="memoComment" placeholder="add a comment"></textarea>
            </div>

            <md-dialog-actions class="-action">
                <md-button class="md-primary -cancel" @click="onClickClose()">CLOSE</md-button>
                <md-button class="md-primary -save" @click="onSaveMemo()">SAVE</md-button>
            </md-dialog-actions>
        </md-dialog>
        <md-dialog-confirm :md-active.sync="dialog.active" md-title="Confirm?" :md-content="dialog.content" md-confirm-text="Sure" md-cancel-text="Cancel" @md-cancel="onCancel" @md-confirm="onConfirmalert" />

        <md-dialog :md-active.sync="showDialogFilter" class="dialog-filter-product -freeitem" :md-click-outside-to-close="false">
            <md-dialog-title>All Product</md-dialog-title>
            <div class="layout-dialog" style="display: flex;">
                <div class="md-layout-item md-large-size-35 md-medium-size-35">
                    <!-- <div class="md-layout-item md-large-size-25 md-medium-size-25"> -->
                    <div style="width: 100%;">
                        <div style="margin: 10px 5px 13px 5px;">
                            <multiselect v-model="selectedProoductGroup" id="group" label="title" track-by="code" placeholder="All Product Group" :open-direction="'bottom'" :options="optionsProoductGroup" :searchable="true" :max-height="180" :show-no-results="false" :custom-label="customLabelProoduct" :select-label="''" :deselect-label="''" :selected-label="''" :hide-selected="true" @select="setDataProoduct">
                                <template slot="singleLabel" slot-scope="{ option }">
                                    <div>
                                        <div class="-label">
                                            {{ option.code }} - {{ option.title }}
                                        </div>
                                        <div class="-delete" @mousedown.prevent.stop="clearAll(option.code, 'group')"><i class="material-icons">close</i></div>
                                    </div>
                                </template>
                            </multiselect>
                        </div>
                    </div>
                    <!-- <div class="md-layout-item md-large-size-25 md-medium-size-25"> -->
                    <div style="width: 100%;">
                        <div style="margin: 10px 5px 13px 5px;">
                            <multiselect v-model="selectedProoductSubGroup" id="subgroup" label="title" track-by="code" placeholder="All Sub Group" :open-direction="'bottom'" :options="optionsProoductSubGroup" :searchable="true" :max-height="180" :show-no-results="false" :custom-label="customLabelProoduct" :select-label="''" :deselect-label="''" :selected-label="''" :hide-selected="true" @select="setDataProoduct">
                                <template slot="singleLabel" slot-scope="{ option }">
                                    <div>
                                        <div class="-label">
                                            {{ option.code }} - {{ option.title }}
                                        </div>
                                        <div class="-delete" @mousedown.prevent.stop="clearAll(option.code, 'subgroup')"><i class="material-icons">close</i></div>
                                    </div>
                                </template>
                            </multiselect>
                        </div>
                    </div>
                    <!-- <div class="md-layout-item md-large-size-25 md-medium-size-25"> -->
                    <div style="width: 100%;">
                        <div style="margin: 10px 5px 13px 5px;">
                            <multiselect v-model="selectedProoductCG" id="cg" label="title" track-by="code" placeholder="All CG" :open-direction="'bottom'" :options="optionsProoductCG" :searchable="true" :max-height="180" :show-no-results="false" :custom-label="customLabelProoduct" :select-label="''" :deselect-label="''" :selected-label="''" :hide-selected="true" @select="setDataProoduct">
                                <template slot="singleLabel" slot-scope="{ option }">
                                    <div>
                                        <div class="-label">
                                            {{ option.code }} - {{ option.title }}
                                        </div>
                                        <div class="-delete" @mousedown.prevent.stop="clearAll(option.code, 'cg')"><i class="material-icons">close</i></div>
                                    </div>
                                </template>
                            </multiselect>
                        </div>
                    </div>
                    <!-- <div class="md-layout-item md-large-size-25 md-medium-size-25"> -->
                    <!-- <div style="width: 96%;">
                        <md-field class="md-search-box">
                            <i class="md-icon material-icons">search</i>
                            <md-input type="text" placeholder="Search by Code or Name.." v-model="searchFilterProductName"></md-input>
                        </md-field>
                    </div> -->
                    <div class="filter-table" style="width: 100%;">
                        <input type="text" v-model="searchFilterProductCode" placeholder="Search by product code....">
                    </div>

                    <div class="filter-table" style="width: 100%; margin-top: 10px;">
                        <input type="text" v-model="searchFilterProductName" placeholder="Search by product name....">
                    </div>

                    <div style="text-align: center; margin-top: 20px;">
                        <md-button class="md-raised md-primary filter-search" @click="searchProduct()">SEARCH</md-button>
                    </div>

                    <!-- <div class="check-condition" style="margin-top: 30px;">** Product ที่มีสถานะเป็น Inactive จะไม่นำมาแสดง</div>
                    <div class="check-condition">** Product ที่มี Product Lift Cycle นอกจากที่กำหนดไว้ จะไม่นำมาแสดง</div>
                    <div class="check-condition">** Product ที่ไม่มีการตั้งราคา A3 ไว้ จะไม่นำมาแสดง</div> -->

                    <!-- <div v-show="(checkCondition == true)" class="-conditions">
                        <div class="title" style="width: 100%;">Check conditions</div>
                        <div style="width: 100%;">
                            <ul>
                                <li>Product ที่มีสถานะเป็น Inactive จะไม่นำมาแสดง</li>
                                <li>Product ที่มี Product Lift Cycle นอกจากที่กำหนดไว้ จะไม่นำมาแสดง</li>
                                <li>Product ที่ไม่มีการตั้งราคา A3 ไว้ จะไม่นำมาแสดง</li>
                            </ul>
                        </div>
                    </div> -->

                </div>

                <div class="md-layout-item md-large-size-65 md-medium-size-65 mkt-ops -main-font" style="padding-left: 25px;">
                    <div id="table-product-filter">
                        <div id="divHeadList">
                            <div style="width: 6%;">
                                <label class="-mkt-checkbox-container">
                                    <input type="checkbox" @click="selectAllProductFilter" v-model="checkedProductFilterAll">
                                    <span class="-mkt-checkbox"></span>
                                </label>
                            </div>
                            <div style="width: 12%;">Code</div>
                            <div style="width: 67%;">Name</div>
                            <!-- <div style="width: 7%;" class="-text-center">Stock</div> -->
                            <!-- <div style="width: 7%;" class="-text-center">Class</div> -->
                            <div style="width: 15%;" class="-text-center">Unit</div>
                            <!-- <div style="width: 13%;" class="-text-right">Default Price</div>
                            <div style="width: 11%;" class="-text-right">Cost</div> -->
                        </div>
                        <div id="divBodyList">
                            <div v-show="(tbListProduct == null || tbListProduct.length == 0)" :class="'row-bg-gray'" style="display: block; text-align: center;">No data in table.</div>
                            <div :class="'row-bg-gray'" v-for="(item, rIndex) in tbListProduct" :key="rIndex">
                                <div style="width: 6%;">
                                    <label class="-mkt-checkbox-container">
                                        <input type="checkbox" v-model="checkedProductFilter" :id="item.code" :value="item.code" @click="selectProductFilter(item.code)">
                                        <span class="-mkt-checkbox"></span>
                                    </label>
                                </div>
                                <div style="width: 12%;">{{ item.code }}</div>
                                <div style="width: 67%;" class="nowrap-title -font-kanit">
                                    <span :title="item.title_th">{{ item.title_th }}</span>
                                </div>
                                <!-- <div style="width: 7%;" class="-text-center">{{ item.stock }}</div> -->
                                <!-- <div style="width: 7%;" class="-text-center">{{ item.class }}</div> -->
                                <!-- <div style="width: 7%;" class="-text-center">{{ item.productpmd_code }}</div> -->
                                <div style="width: 15%;" class="-text-center">{{ item.seu_code }}</div>
                                <!-- <div style="width: 13%;" class="-text-right">{{ (item.price != '' ? formatNumber(item.price, 2) : '')}}</div>
                                <div style="width: 11%;" class="-text-right">{{ (item.cost != '' ? parseFloat(item.cost).toFixed(2): '')}}</div> -->
                            </div>
                        </div>
                        <div class="footer-table">number of lines in table ({{tbListProduct.length}})</div>
                    </div>
                </div>
            </div>

            <md-dialog-actions class="-action">
                <md-button class="md-primary -cancel" @click="onClickCloseProduct()">CLOSE</md-button>
                <md-button :class="(disableAddData && checkedProductFilter.length == 0) ? 'md-primary -save -disabled' : 'md-primary -save'" :disabled="disableAddData" @click="onclickAddProduct()">ADD TO TABLE</md-button>
            </md-dialog-actions>
        </md-dialog>
        
        <DialogAlertCondition ref="dialogAlertCondition" v-model="showDialogAlert" :completeProduct="completeProduct" :lostProduct="alertProductLost" @cilckOK="onCilckOK"></DialogAlertCondition>
    </div>
</div>
</template>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<script>
import PricingService from "@/services/pricing";
import PromotionService from "@/services/promotion";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import {
    ASYNC_SEARCH
} from "@riophae/vue-treeselect";
import _ from "lodash";
const simulateAsyncOperation = fn => {
    setTimeout(fn, 2000);
};
/* eslint-disable */
import Multiselect from "vue-multiselect";
import { constants } from 'crypto';
import promotionService from "@/services/promotion";
import DialogAlertCondition from "@/components/shared/dialog-alert-condition";

export default {
    name: "step3",
    created() {
        this.$store.dispatch("pmcreate/getCustomerGroups");
        this.$store.dispatch("pmcreate/getDefaultPrice");
    },
    components: {
        stepper: require("@/components/promotion/create/stepper").default,
        Multiselect,
        Treeselect,
        DialogAlertCondition
    },
    mounted(){
        this.$store.commit("pmmanage/loadingPage", false);
        this.dataOption = this.$store.getters["pmcreate/origin_customer_groups"];
    },
    computed: {
        loadData() {
            return this.$store.getters["pmmanage/loadData"];
        },
        sets() {
            this.setEditAndDuplicateForCustomer(this.$store.getters["pmcreate/sets"]);
            return this.$store.getters["pmcreate/sets"];
        },
        customerGroups() {
            // console.log("AA ==>",this.$store.getters['pmcreate/customer_groups']);
            if(this.dataOption.length !== undefined && this.dataOption.length === 0){
                this.dataOption = JSON.parse(JSON.stringify(this.$store.getters['pmcreate/customer_groups']));
            }
            return this.$store.getters["pmcreate/customer_groups"];
        },
        defailtPrice() {
            return this.$store.getters["pmcreate/default_price"];
        },
        value() {
            return this.$store.getters["pmcreate/value"];
        },
        alertshow: {
            get() {
                return this.$store.getters["pmcreate/alertshow"];
            },
            set(value) {
                this.$store.commit("pmcreate/setAlertShow", {
                    value
                });
            }
        },
        alertcontent() {
            return this.$store.getters["pmcreate/alertcontent"];
        }
    },
    data: () => ({
        saveDisabled: false,
        memoComment: "",
        showDialogComment: false,
        // menuConditions: ["QTY", "Value", "Count Item", "Count Value", "Count Mix"],
        menuConditions: ["QTY", "Value", "Count Item", "Count Value"],
        menuPromotions: ["Discount", "Net Price", "Free item"],
        selectTab: null,
        boolean: false,
        showSnackbar: false,
        dContent: "",
        position: "center",
        duration: 20000,
        isInfinity: false,
        customer: [],
        dataOption: [],
        addprouct_freeitem: "",
        showDialog: false,
        alertconfirm: false,
        alertCondition: false,
        alertConditionContent: "",
        indexdelete: "",
        alert: false,
        active: false,
        activeMaxValue: false,
        type: null,
        dialog_title: null,
        dialog_title_max: null,
        valueTree: [],
        valueConsistsOf: "LEAF_PRIORITY",
        current_set: 0,
        temp_freeitem: [],
        temp_pm_set: [],
        search: "",
        dialog: {
            active: false,
            content: ""
        },
        checkedProductsAll: false,
        checkedProducts: [],
        selectedCondition:  0,
        itemCondition: ["QTY", "Pick up item", "Ratio"],
        checkedProductFilter: [],
        checkedProductFilterAll: false,
        selectedProoductGroup: [],
        optionsProoductGroup: [],
        selectedProoductSubGroup: [],
        optionsProoductSubGroup: [],
        selectedProoductCG: [],
        optionsProoductCG: [],
        searchFilterProductCode: '',
        searchFilterProductName: '',
        tbListProduct: [],
        showDialogFilter: false,
        // disableAddData: true,
        disableAddData: false,
        loadDialog: false,
        showDialogAlert: false,
        completeProduct: "",
        alertProductLost: "",
        checkCondition: false,
        checkAleartNetPrice: false,
        checkSaveAleartNetPrice: false,
        indexSet: "",
        indexPM: "",
        clickOutside: false
    }),
    watch: {
        customerGroups: function(newValue, oldValue){
//              console.info('newV', JSON.stringify(newValue));
//                console.info('oldV', oldValue);
//                console.log('option', this.dataOption);
//                console.log('model', this.customer);
        }
    },
    methods: {
        onCilckOK() {
            this.showDialogAlert = false;
            this.loadDialog = false;
        },
        getAllProduct(datas) {
            promotionService.getAllProduct(datas).then(response => {
                    if (response) {
                        this.optionsProoductGroup = (response.data.product_group !== undefined) ? response.data.product_group.sort((a, b) => (a.code > b.code) ? 1 : -1) : [];
                        this.optionsProoductSubGroup = (response.data.product_subgroup !== undefined) ? response.data.product_subgroup.sort((a, b) => (a.code > b.code) ? 1 : -1) : [];
                        this.optionsProoductCG = (response.data.product_cg !== undefined) ? response.data.product_cg.sort((a, b) => (a.code > b.code) ? 1 : -1) : [];

                        if(datas !== undefined && datas.type == 'subgroup') {
                            this.selectedProoductGroup = response.data.product_group[0];
                        } else if(datas !== undefined && datas.type == 'cg') {
                            this.selectedProoductGroup = response.data.product_group[0];
                            this.selectedProoductSubGroup = response.data.product_subgroup[0];
                        }
                    }
                })
                .catch();
        },
        getAllProductSearch(datas) {
            this.$store.commit("pmmanage/loadingPage", true);

            let self = this;
            this.temp_freeitem.forEach(function (value, key) {
                self.checkedProductFilter.push(value.code);
            });
            
            promotionService.getAllProductSearch(datas).then(response => {
                    if (response) {
                        if(response.data.length > 0) {
                            this.tbListProduct = response.data.sort((a, b) => (a.code > b.code) ? 1 : -1);
                            this.checkCondition = false;
                        } else {
                            this.tbListProduct = [];
                            // this.checkCondition = true;
                        }
                        // this.tbListProduct = (response.data !== undefined) ? response.data.sort((a, b) => (a.code > b.code) ? 1 : -1) : [];
                    }
                    this.checkedProductFilterAll = false;
                    this.$store.commit("pmmanage/loadingPage", false);
                })
                .catch();
        },
        selectProductFilter(code) {
            if(this.checkedProductFilter.indexOf(code) == -1) {
                this.checkedProductFilter.push(code);
            } else {
                this.checkedProductFilter.splice(this.checkedProductFilter.indexOf(code), 1);
                let index = this.temp_freeitem.findIndex(item => item.code === code);
                this.temp_freeitem.splice(index, 1);
                this.valueTree.splice(index, 1);
            }

            // this.disableAddData = (this.checkedProductFilter.length > 0) ? false : true;
        },
        selectAllProductFilter() {
            this.checkedProductFilter = [];
            if (!this.checkedProductFilterAll) {
                for (let itemCode in this.tbListProduct) {
                    if(this.tbListProduct[itemCode].used === undefined || this.tbListProduct[itemCode].used == false) {
                        this.checkedProductFilter.push(this.tbListProduct[itemCode].code);
                    }
                }
                // this.disableAddData = (this.checkedProductFilter.length > 0) ? false : true;
            } else {
                // this.disableAddData = (this.checkedProductFilter.length > 0) ? false : true;
            }
        },
        clearAll(id, type) {
            if (type == 'group') {
                this.selectedProoductGroup = [];
                this.selectedProoductSubGroup = [];
                this.selectedProoductCG = [];
                this.getAllProduct();
            } else if (type == 'subgroup') {
                let datas = { type: 'group', code:  this.selectedProoductGroup.code};
                this.selectedProoductSubGroup = [];
                this.selectedProoductCG = [];
                this.getAllProduct(datas);
            } else if (type == 'cg') {
                let datas = { type: 'subgroup', code:  this.selectedProoductSubGroup.code};
                this.selectedProoductCG = [];
                this.getAllProduct(datas);
            }
        },
        searchProduct() {
            let v_group = this.selectedProoductGroup.code;
            let v_subgroup = this.selectedProoductSubGroup.code;
            let v_cg = this.selectedProoductCG.code;
            if((v_group == "" || v_group == null) && (v_subgroup == "" || v_subgroup == null) && (v_cg == "" || v_cg == null) && 
            (this.searchFilterProductCode == "" || this.searchFilterProductCode ==null) && (this.searchFilterProductName == "" || this.searchFilterProductName == null)) {
                this.showSnackbar = true;
                this.dContent = "Please select or fill in the input you want to search."
            } else {
                let datas = { group: v_group, subgroup: v_subgroup, cg: v_cg, code: this.searchFilterProductCode, name: this.searchFilterProductName, searchtype: 'freeitem' };
                this.getAllProductSearch(datas);
            }
        },
        setDataProoduct(selectedOption, id) {
            let datas = { type: id, code: selectedOption.code };
            this.getAllProduct(datas);
        },
        customLabelProoduct({
            code,
            title
        }) {
            return `${code} - ${title}`
        },
        onclickAddProduct() {
            for(let i = 0; i < this.tbListProduct.length; i++) {
                let index = this.temp_freeitem.findIndex(item => item.code === this.tbListProduct[i].code);
                if(index < 0) {
                    // this.products.push(this.tbListProduct[i])
                    if(this.checkedProductFilter.indexOf(this.tbListProduct[i].code) > -1) {
                        this.valueTree = _.union(this.valueTree, [this.tbListProduct[i].id]);
                        this.openOnSelectTreeview(this.tbListProduct[i])
                    }
                }
            }
            this.showDialogFilter = false;
            // this.disableAddData = true;

            this.selectedProoductGroup = [];
            this.selectedProoductSubGroup = [];
            this.selectedProoductCG = [];
            this.searchFilterProductCode = "";
            this.searchFilterProductName = "";
            this.tbListProduct = [];
            this.checkedProductFilterAll = false;
            this.checkedProductFilter = [];
            this.loadDialog = false;
            this.checkCondition = false;
        },
        onClickCloseProduct() {
            this.selectedProoductGroup = [];
            this.selectedProoductSubGroup = [];
            this.selectedProoductCG = [];
            this.searchFilterProductCode = "";
            this.searchFilterProductName = "";
            this.tbListProduct = [];
            this.showDialogFilter = false;
            this.checkedProductFilterAll = false;
            this.checkedProductFilter = [];
            this.loadDialog = false;
            this.checkCondition = false;
        },
        onClickDialogFilter() {
            this.getAllProduct();
            this.showDialogFilter = true;
            this.loadDialog = true;
        },
        disabledInput(item_free, v_item_free) {
            // if(this.temp_pm_set.number_of_item_flag) {
            if(this.selectedCondition != 0) {
                item_free.qty = "";
                item_free.ratio[0] = "";
                item_free.ratio[1] = "";
                
                item_free.ck_qty = "";
                item_free.ck_ratio = "";

                if(this.selectedCondition == 1) {
                    this.temp_pm_set.ratio0_of_item = "";
                    this.temp_pm_set.ratio1_of_item = "";
                } else if(this.selectedCondition == 2) {
                    this.temp_pm_set.number_of_item = "";
                }

                return true;
            } if(item_free.status == 'Inactive') {
                return true;
            } else {
                this.temp_pm_set.number_of_item = "";
                this.temp_pm_set.ratio0_of_item = "";
                this.temp_pm_set.ratio1_of_item = "";

                if(v_item_free == '#efefef') {
                    return true;
                } else {
                    return false;
                }
            }
        },
        isNumber(evt) {
            evt = evt ? evt : window.event;
            var charCode = evt.which ? evt.which : evt.keyCode;
            if (charCode > 31 && (charCode < 48 || charCode > 57)) {
                this.keepEvent = false;
                evt.preventDefault();
            } else {
                this.keepEvent = true;
                return true;
            }
        },
        onConfirmalert() {
            this.checkSaveAleartNetPrice = true;
            this.showDialogsave('Draft', 'continue');
            // return true;
        },
        onCancel() {
            this.checkSaveAleartNetPrice = false;
            this.checkAleartNetPrice = false;
            this.showDialogsave('Draft', 'continue');
            // return false;
        },
        async onSaveMemo() {
            
            this.showDialogComment = false;
            this.$store.commit('pmcreate/setComment', this.memoComment);
            this.$store.dispatch("pmcreate/setFormatDate");
            this.$store.commit("pmcreate/setType", this.type);
            let create_rs = await this.$store.dispatch("pmcreate/createPromotionToServer");
            if(create_rs === false){
                this.$store.commit("pmmanage/loadingPage", false);
                this.dContent = "Can not get approve by.";
                this.showSnackbar = true;
                this.saveDisabled = false;
            }
            // this.$store.dispatch("pmcreate/createPromotionToServer");
            this.$store.commit("pmmanage/closeApvDialog");
            this.memoComment = "";
        },
        onClickClose() {
            this.showDialogComment = false;
        },
        setEditAndDuplicateForCustomer(set){ 
            set.forEach((item, index) => {
                if(this.customer[index] === undefined){
                    let customers = [];
                    item.customers.forEach((customer, key) => {
                        customers.push(customer);
                        //customers.push(JSON.parse(JSON.stringify(customer)));
                    });
                    if(customers.length > 0){
                        this.customer[index] = customers;
                    }
                }
            });
        },
        showDialogsave(type, checkCon) {
            const sets = this.value.sets;
            // var count_ck_sets = 0;
            // var set_fail = [];
            let name_set = [];
            let vMax = "";

            
            /* check alert have net_price by item */
            let setsLength = sets.length;
            let lastSet = sets[(setsLength - 1)];
            let net_price = '';
            lastSet.promotions.forEach(function(item, key){
                if(item.type === 'Net Price'){
                    net_price = item.value;
                }
            });
                let products = this.value.products;
                let self = this;
                let check = false;
                let checknetprice = 0;
                // let checkAleartNetPrice = false;
                if(!self.checkSaveAleartNetPrice || checkCon !== 'continue') {
                    self.checkAleartNetPrice = false;
                    products.forEach(function(item, key){
                        if(net_price !== ''){
                            if(item.netprice !== undefined){
                                self.dialog.content = `Are you sure to set Net price so have Net price by product `;
                                self.dialog.active = true;
                                self.checkAleartNetPrice = true;
                            }
                        }
    
                        self.value.products[key].min = (item.min == "" && item.min != 0) ? '' : item.min;
                        self.value.products[key].max = (item.max == "" && item.max != 0) ? '' : item.max;
    
                        if(item.min == "" || item.max == "") {
                            check = true;
                            return;
                        }
    
                        if(parseFloat(item.netprice) > 0) {
                            checknetprice++;
                        }
                    });

                    if(self.checkAleartNetPrice) {
                        // self.alertCondition = false;
                        return;
                    }
                }

            if(checknetprice > 0) {
                this.$store.commit('pmcreate/setNetPriceFlag', true);
            }

            for (const x in sets) {
                // if(sets[x].name && sets[x].default_price && sets[x].conditions.length > 0 && sets[x].promotions.length > 0 && sets[x].customers.length > 0){
                // 	count_ck_sets++
                // }else{
                // 	set_fail.push(x)
                // }

                // if(sets[x].conditions.length > 0 && (parseFloat(sets[x].conditions[0].min) >= parseFloat(sets[x].conditions[0].max))) {
                    // 	this.alertConditionContent = "Value max must be greater than value min"
                // 	this.alertCondition = true;
                // 	return;
                // }


                // if((check) && sets[x].conditions.length == 0) {
                //     this.alertConditionContent = "Please enter min-max net price on step 2 Or Please select Conditions";
                //     this.alertCondition = true;
                //     return;
                // }

                if (name_set.indexOf(sets[x].name) == -1) {
                    // ไม่มี
                    name_set.push(sets[x].name);
                } else {
                    this.alertConditionContent =
                        '"' + sets[x].name.toUpperCase() + '"' + " duplicate set name";
                    this.alertCondition = true;
                    return;
                }

                if (sets[x].customers.length <= 0) {
                    this.alertConditionContent = "Please select customer";
                    this.alertCondition = true;
                    return;
                }

                if (sets[x].name == "") {
                    this.value.sets[x].name = "SET " + (parseFloat(x) + 1);
                }

                if (sets[x].default_price || sets[x].default_price == "") {
                    if (sets[x].name == "") {
                        this.alertConditionContent = "Please input Name";
                        this.alertCondition = true;
                        return;
                    } else if (sets[x].customers.length <= 0) {
                        this.alertConditionContent = "Please select customer";
                        this.alertCondition = true;
                        return;
                    } else if (sets[x].default_price == "" || sets[x].default_price == null) {
                        this.alertConditionContent = "Please select Price Type";
                        this.alertCondition = true;
                        return;
                    }
                }
                
                if(setsLength > 1 && sets[x].conditions.length == 0) {
                    this.alertConditionContent = "Please select Conditions";
                    this.alertCondition = true;
                    return;
                }

                if (sets[x].conditions.length > 0) {
                    if(sets[x].conditions[0].type == "Count Mix") {
                        if(sets[x].conditions[0].count === undefined || sets[x].conditions[0].count == "") {
                            this.alertConditionContent = "Please input Count Item (≥)";
                            this.alertCondition = true;
                            return;
                        }

                        if((sets[x].conditions[0].min == "" || sets[x].conditions[0].min == null) &&
                            (sets[x].conditions[0].max == "" || sets[x].conditions[0].max == null)
                        ) {
                            this.alertConditionContent = "QTY min can not null <br> QTY max can not null";
                            this.alertCondition = true;
                            return;
                        }

                        if((sets[x].conditions[0].min_value == "" || sets[x].conditions[0].min_value == null) &&
                            (sets[x].conditions[0].max_value == "" || sets[x].conditions[0].max_value == null)
                        ) {
                            this.alertConditionContent = "Value min can not null <br> Value max can not null";
                            this.alertCondition = true;
                            return;
                        }

                        if((sets[x].conditions[0].min != "" && sets[x].conditions[0].min != null) &&
                            (sets[x].conditions[0].max == "" || sets[x].conditions[0].max == null)
                        ) {
                            this.alertConditionContent = "QTY max can not null";
                            this.alertCondition = true;
                            return;
                        }

                        if((sets[x].conditions[0].min_value != "" && sets[x].conditions[0].min_value != null) &&
                            (sets[x].conditions[0].max_value == "" || sets[x].conditions[0].max_value == null)
                        ) {
                            this.alertConditionContent = "Value max can not null";
                            this.alertCondition = true;
                            return;
                        }

                        if((sets[x].conditions[0].max != "" && sets[x].conditions[0].max != null) &&
                            (sets[x].conditions[0].min == "" || sets[x].conditions[0].min == null)
                        ) {
                            this.alertConditionContent = "QTY min can not null";
                            this.alertCondition = true;
                            return;
                        }

                        if((sets[x].conditions[0].max_value != "" && sets[x].conditions[0].max_value != null) &&
                            (sets[x].conditions[0].min_value == "" || sets[x].conditions[0].min_value == null)
                        ) {
                            this.alertConditionContent = "Value min can not null";
                            this.alertCondition = true;
                            return;
                        }

                        if (sets[x].conditions[0].min == "" || sets[x].conditions[0].min == null) {
                            this.alertConditionContent = "QTY min can not null";
                            this.alertCondition = true;
                            return;
                        } else if (sets[x].conditions[0].min_value == "" || sets[x].conditions[0].min_value == null) {
                            this.alertConditionContent = "Value min can not null";
                            this.alertCondition = true;
                            return;
                        } else if (sets[x].conditions[0].max == "" || sets[x].conditions[0].max == null) {
                            this.alertConditionContent = "QTY max can not null";
                            this.alertCondition = true;
                            return;
                        } else if (sets[x].conditions[0].max_value == "" || sets[x].conditions[0].max_value == null) {
                            this.alertConditionContent = "Value max can not null";
                            this.alertCondition = true;
                            return;
                        } else if (parseFloat(sets[x].conditions[0].min) > parseFloat(sets[x].conditions[0].max)) {
                            this.alertConditionContent =
                                "QTY max must be greater than QTY min";
                            this.alertCondition = true;
                            return;
                        } else if (parseFloat(sets[x].conditions[0].min_value) > parseFloat(sets[x].conditions[0].max_value)) {
                            this.alertConditionContent =
                                "Value max must be greater than value min";
                            this.alertCondition = true;
                            return;
                        }
                    } else {
                        if((sets[x].conditions[0].type == "Count Item" || sets[x].conditions[0].type == "Count Value") && (sets[x].conditions[0].count === undefined || sets[x].conditions[0].count == "")) {
                            this.alertConditionContent = "Please input Count Item (≥)";
                            this.alertCondition = true;
                            return;
                        }
                        
                        if((sets[x].conditions[0].type == "Count Item" || sets[x].conditions[0].type == "Count Value") &&
                            (sets[x].conditions[0].min == "" || sets[x].conditions[0].min == null) &&
                            (sets[x].conditions[0].max == "" || sets[x].conditions[0].max == null)
                        ) {
                            this.alertConditionContent = "Value min can not null <br> Value max can not null";
                            this.alertCondition = true;
                            return;
                        }
    
                        if((sets[x].conditions[0].type == "Count Item" || sets[x].conditions[0].type == "Count Value") &&
                            (sets[x].conditions[0].min != "" && sets[x].conditions[0].min != null) &&
                            (sets[x].conditions[0].max == "" || sets[x].conditions[0].max == null)
                        ) {
                            this.alertConditionContent = "Value max can not null";
                            this.alertCondition = true;
                            return;
                        }
    
                        if((sets[x].conditions[0].type == "Count Item" || sets[x].conditions[0].type == "Count Value") &&
                            (sets[x].conditions[0].max != "" && sets[x].conditions[0].max != null) &&
                            (sets[x].conditions[0].min == "" || sets[x].conditions[0].min == null)
                        ) {
                            this.alertConditionContent = "Value min can not null";
                            this.alertCondition = true;
                            return;
                        }
    
                        if (
                            (sets[x].conditions[0].type != "Count Item" || sets[x].conditions[0].type != "Count Value") &&
                            (sets[x].conditions[0].min == "" ||
                            sets[x].conditions[0].min == null)
                        ) {
                            this.alertConditionContent = "Value min can not null";
                            this.alertCondition = true;
                            return;
                        } else if (
                            (sets[x].conditions[0].type != "Count Item" || sets[x].conditions[0].type != "Count Value") &&
                            (sets[x].conditions[0].max == "" ||
                            sets[x].conditions[0].max == null)
                        ) {
                            this.alertConditionContent = "Value max can not null";
                            this.alertCondition = true;
                            return;
                        } else if (
                            (sets[x].conditions[0].type != "Count Item" || sets[x].conditions[0].type != "Count Value") &&
                            (parseFloat(sets[x].conditions[0].min) >
                            parseFloat(sets[x].conditions[0].max))
                        ) {
                            this.alertConditionContent =
                                "Value max must be greater than value min";
                            this.alertCondition = true;
                            return;
                        }
                    }


                    // if (sets[x].promotions.length == 0 && this.value.products[0].netprice == 0) {
                    // if (sets[x].promotions.length == 0) {
                    // if (sets[x].promotions.length == 0 && checknetprice == 0) {
                    //     this.alertConditionContent = 'Please select "Set your Promotion"';
                    //     this.alertCondition = true;
                    //     return;
                    // }

                    if (sets[x].default_price == "" || sets[x].default_price == null) {
                        this.alertConditionContent = "Please select Price Type";
                        this.alertCondition = true;
                        return;
                    }

                    if(sets[x].conditions[0].type != "Count Item" || sets[x].conditions[0].type != "Count Value") {
                        vMax = sets[x].conditions[0].max;
                    }
                }

                if (sets[x].promotions.length > 0) {
                    if(sets[x].conditions.length == 0) {
                        this.alertConditionContent = "Please select Condition";
                        this.alertCondition = true;
                        return;
                    }

                    for (const y in sets[x].promotions) {
                        // console.log("==>", (sets[x].promotions[y].value != 0));
                        // console.log("==>", (sets[x].promotions[y].value == ""));
                            // sets[x].promotions[y].value != 0 &&
                        if (
                            sets[x].promotions[y].type != 'Free item' &&
                            (sets[x].promotions[y].value == "" ||
                            sets[x].promotions[y].value == null ||
                            isNaN(sets[x].promotions[y].value) === true)
                        ) {
                            this.alertConditionContent =
                                "Value of " + sets[x].promotions[y].type + " can not null";
                            this.alertCondition = true;
                            return;
                        }

                        // if(sets[x].promotions[y].type == "Net Price") {
                        //     this.$store.commit('pmcreate/setNetPriceFlag', false);
                        // }
                    }

                    if (sets[x].default_price == "" || sets[x].default_price == null) {
                        this.alertConditionContent = "Please select Price Type";
                        this.alertCondition = true;
                        return;
                    }
                }
            }

            this.$store.dispatch("pmcreate/ck_range");
            let alertCondition = this.$store.getters["pmcreate/alertCondition"];
            let ck_value_condition = alertCondition.length ? false : true;
            if (alertCondition) {
                this.alertConditionContent = alertCondition;
                this.alertCondition = true;
                return;
            }

            // if(this.value.promotion_code && this.value.promotion_title && this.value.startdate && this.value.enddate && this.value.products.length > 0 && (count_ck_sets == sets.length) && ck_value_condition){
            if (ck_value_condition) {

                if(this.value.type == "Return") {
                    type = "Return";
                }
                
                this.type = type;
                let index_max_set = sets.length - 1;
                let index_max_con = sets[index_max_set].conditions.length - 1;
                if((sets[index_max_set].conditions.length > 0) && (sets[index_max_set].conditions[index_max_con].type == "Count Item" || sets[index_max_set].conditions[index_max_con].type == "Count Value") && 
                    (sets[index_max_set].conditions[index_max_con].min == "" || sets[index_max_set].conditions[index_max_con].min == null) &&
                    (sets[index_max_set].conditions[index_max_con].max == "" || sets[index_max_set].conditions[index_max_con].max == null)) {
                        this.active = true;
                    } else {
                        if(index_max_con >= 0 && !sets[index_max_set].conditions[index_max_con].max_level) {
                            let vMax = sets[index_max_set].conditions[index_max_con].max;
                            this.dialog_title_max = "<div class='alert-max'> การกำหนดค่า Max ที่ ("+ vMax +") เป็น Rate สูงสุดที่ใช้กับโปรโมชั่นชุดนี้ </div>";
                            this.activeMaxValue = true;
                        } else {
                            this.active = true;
                        }
                    }


                // this.dialog_title = "<div class='alert-max'> การกำหนดค่า Max ที่ ("+ vMax +") เป็น Rate สูงสุดที่ใช้กับโปรโมชั่นชุดนี้ </div>";
                // this.dialog_title = "<div class='alert-max'> การกำหนดค่า Max ที่ (จำนวน) เป็น Rate สูงสุดที่ใช้กับโปรโมชั่นชุดนี้ </div>";
                // this.dialog_title = "<div> Are you sure to save ? </div>";
                // this.type = type;
                // this.active = true;
            } else {
                let word_fail = "Please recheck your ";
                for (const x in set_fail) {
                    word_fail += "SET" + (parseInt(set_fail[x]) + 1) + " ";
                }
                this.alertConditionContent = word_fail;
                this.alertCondition = true;
            }

            // let promotions_all = this.$store.getters["pmmanage/promotions_all"];
            // let data_promotions_all = promotions_all.find(a => a.promotion_id === this.value.promotion_id);
            // console.log("this.value ==>", this.value);
            // console.log("data_promotions_all ==>", data_promotions_all);

            // let check_change_data = _.isEqual(JSON.stringify(data_promotions_all), JSON.stringify(this.value));
            // console.log("check_change_data ==>", check_change_data);

            // console.log("stringify ==>", JSON.stringify(data_promotions_all) === JSON.stringify(this.value));
        },
        async onConfirm() {
            // this.showDialogComment = true;
            
            this.saveDisabled = true;
            this.$store.commit("pmmanage/loadingPage", true);
            this.$store.dispatch("pmcreate/setFormatDate");
            this.$store.commit("pmcreate/setType", this.type);
            let create_rs = await this.$store.dispatch("pmcreate/createPromotionToServer");
            if(create_rs === false){
                this.$store.commit("pmmanage/loadingPage", false);
                this.dContent = "Can not get approve by.";
                this.showSnackbar = true;
                this.saveDisabled = false;
            }
            // this.$store.dispatch("pmcreate/createPromotionToServer");
            this.$store.commit("pmmanage/closeApvDialog");
        },
        onCancel() {
            this.active = false;
            this.activeMaxValue = false;
        },
        inputNetPrice(value, index, index_promotion, index_product) {
            this.$store.dispatch("pmcreate/changeNetPrice", {
                value,
                index,
                index_promotion,
                index_product
            });
        },
        onTouch(index) {
            setTimeout(function () {
                document.getElementById("div_result_" + index).style.marginTop = "8px";
            }, 300);
        },
        onCustomerGroupClick(index) {
            //document.getElementById("div_result_"+index).style.marginTop = "158px"
        },
        condition_new(index, type) {
            this.$store.dispatch("pmcreate/insertCondition", {
                index,
                type
            });
        },
        condition_delete(index, index_condition) {
            this.$store.dispatch("pmcreate/deleteCondition", {
                index,
                index_condition
            });
        },
        changeConditions(index, type) {
            this.$store.dispatch("pmcreate/updateCondition", {
                index,
                type
            });

            this.$store.dispatch("pmcreate/ck_range");
            let vvv = this.$store.getters["pmcreate/alertCondition"];
            if (vvv) {
                this.alertConditionContent = vvv;
                this.alertCondition = true;
            }
        },
        promotion_new(index, type) {
            this.$store.dispatch("pmcreate/insertPromotion", {
                index,
                type
            });

            if(type == "Free item") {
                let sets = this.$store.getters["pmcreate/sets"];
                let index_promotion = sets[index].promotions.length - 1;
                this.promotion_showDialog(index, index_promotion);
            }
        },
        promotion_delete(index, index_promotion) {
            this.$store.dispatch("pmcreate/deletePromotion", {
                index,
                index_promotion
            });
        },
        changePromotion(index, type) {
            this.$store.dispatch("pmcreate/updatePromotion", {
                index,
                type
            });
        },
        customer_new(index) {
            //const customer = this.customer;
            const customer = this.customer[index];
//            const customer = JSON.parse(JSON.stringify(this.customer[index]));
            this.$store.dispatch("pmcreate/insertCustomer", {
                index,
                customer
            });
        },
        customer_delete(index, index_customer) {
            let tmp_cus = JSON.parse(JSON.stringify(this.customer));
            tmp_cus[index].splice(index_customer, 1);
            this.customer = tmp_cus;
            this.$store.dispatch("pmcreate/deleteCustomer", {
                index,
                index_customer
            });
        },
        set_new(index, index_tab) {
            const next_index = this.sets.length;
            this.customer[next_index] = [];
            this.selectTab = 'tab-'+ this.sets.length;
            this.$store.dispatch('pmcreate/insertSet', index);
            if(index >= 0){
                const customer = JSON.parse(JSON.stringify(this.customer[index]));
                index = next_index;
                this.$store.dispatch('pmcreate/insertCustomer', {index,customer})
                this.customer[next_index] = customer;
            }
        },
        set_reset(index) {
            this.$store.dispatch("pmcreate/resetSet", index);
        },
        set_delete(index) {
            this.indexdelete = index;
            this.alertconfirm = true;
        },
        nextStep(step) {
            this.$store.commit("pmcreate/setStep", step);
        },
        checkShowMenu(conditions, value) {
            let check = true;
            for (const x in conditions) {
                if (conditions[x].type == value) {
                    check = false;
                    break;
                }
            }
            return check;
        },
        checkShowMenuDisabled(conditions, value) {
            let check = false;
            for (const x in conditions) {
                if (conditions[x].type != value) {
                    check = true;
                    break;
                }
            }
            return check;
        },
        addProductPromotion(setIndex, index) {
            if (this.addprouct_freeitem != 0)
                this.$store.dispatch("pmcreate/checkCodeFreeItem", {
                    code: this.addprouct_freeitem,
                    setIndex,
                    index
                });
        },
        onClosedialog() {
            let sets = this.$store.getters["pmcreate/sets"];
            let promotion = sets[this.indexSet].promotions[this.indexPM];
            if(promotion.type == 'Free item' && promotion.value.length == 0) {
                this.promotion_delete(this.indexSet, this.indexPM);
            }
            this.showDialog = false;
        },
        onSavedialog(vIndex, index_promotion, item_promotion) {

            // let index = vIndex - 1;
            let index = this.current_set;
            // if(this.selectedCondition == 1 && this.temp_pm_set.number_of_item_flag && this.temp_pm_set.number_of_item.toString().trim() == '') {
            if(this.selectedCondition == 1 && this.temp_pm_set.number_of_item.toString().trim() == '') {
                this.dContent = "Please input condition of Pick up.";
                this.showSnackbar = true;
                return false;
            }
            if(this.selectedCondition == 2 && (this.temp_pm_set.ratio0_of_item.toString().trim() == '' || this.temp_pm_set.ratio1_of_item.toString().trim() == '')) {
                this.dContent = "Please input condition of Ratio.";
                this.showSnackbar = true;
                return false;
            }
            
            let temp_freeitem = this.temp_freeitem;
            if(this.selectedCondition == 0 && temp_freeitem.length == 0) {
                this.dContent = "Please select ITEMS IN GROUP.";
                this.showSnackbar = true;
                return false;
            }

            let hasAlert = false;
            temp_freeitem.forEach((item) => {
                if(
                    // (item.qty.trim() === '' || item.qty <= 0) && 
                    // (item.ratio[0].trim() === '' || item.ratio[0] <= 0 || item.ratio[1].trim() === '' || item.ratio[1] <= 0)
                    (item.qty === '' || item.qty <= 0) && 
                    (item.ratio[0] === '' || item.ratio[0] <= 0 || item.ratio[1] === '' || item.ratio[1] <= 0)
                ){
                    hasAlert = true;
                    return false;
                }
            });

            if(hasAlert && this.selectedCondition == 0){
                this.dContent = "Please input condition of QTY in table.";
                this.showSnackbar = true;
                return false;
            }            

            // console.log("index ==>", index);
            this.$store.dispatch("pmcreate/updatePromotion_freeItem", {
                index,
                temp_freeitem
            });

            // console.log("index_promotion ==>", index_promotion);
            let tmp = parseFloat(this.temp_pm_set.number_of_item)
            this.sets[index].promotions[index_promotion].number_of_item = (isNaN(tmp))? '' : tmp
            this.sets[index].promotions[index_promotion].number_of_item_flag = (this.selectedCondition == 1) ? true : false
            this.sets[index].promotions[index_promotion].ratio_flage = (this.selectedCondition == 2) ? true : false
            let ratio0_of_item = (this.temp_pm_set.ratio0_of_item == '') ? '' : parseFloat(this.temp_pm_set.ratio0_of_item)
            let ratio1_of_item = (this.temp_pm_set.ratio1_of_item == '') ? '' : parseFloat(this.temp_pm_set.ratio1_of_item)
            this.sets[index].promotions[index_promotion].ratio = { 
                0 : ratio0_of_item,
                1 : ratio1_of_item
            }

            // console.log("this.sets ==>", this.sets);

            this.showDialog = false;
        },
        checkSelectTab(activeTab) {
            this.selectTab = activeTab;
        },
        onConfirmDelete() {
            if (this.indexdelete) {
                const nextindex = this.sets.length;
                let indexactive = nextindex - 2;
                this.$store.dispatch("pmcreate/deleteSet", this.indexdelete);
                //this.selectTab = "tab-0";
                this.selectTab = "tab-"+indexactive;
                /*setTimeout(() => {
                    this.selectTab = "null;
                }, 5000);*/
                this.indexdelete = "";
                this.alertconfirm = false;

                // this.$refs.reftab.$el.children[1].children[0].style.transform = 'translate3d(0%, 0px, 0px)';
                // console.log("this.$refs.reftab.$el ==>", this.$refs.reftab.$el.children[1].children[0]);
            }
        },
        onCancelDelete() {
            this.alertconfirm = false;
        },
        promotion_showDialog(index, index_promotion) {
            this.indexSet = index;
            this.indexPM = index_promotion;
            this.temp_freeitem = [];
            this.valueTree = [];
            var self = this;
            let promotions = this.$store.state["pmcreate"].value.sets[index].promotions[index_promotion];
            let arr_promotion = promotions.value;

            let number_of_flag = (promotions.number_of_item_flag !== undefined) ? promotions.number_of_item_flag : false;
            let ratio_of_flag = (promotions.ratio_flage !== undefined) ? promotions.ratio_flage : false;
            if(number_of_flag !== undefined && number_of_flag == true) {
                this.selectedCondition = 1;
            } else if(ratio_of_flag !== undefined && ratio_of_flag == true) {
                this.selectedCondition = 2;
            } else {
                this.selectedCondition = 0;
            }

            this.temp_pm_set = {
                number_of_item : (promotions.number_of_item !== undefined) ? promotions.number_of_item : '',
                number_of_item_flag : number_of_flag,
                ratio_flage : ratio_of_flag,
                ratio0_of_item : (promotions.ratio !== undefined) ? promotions.ratio[0] : '',
                ratio1_of_item : (promotions.ratio !== undefined) ? promotions.ratio[1] : ''
            };

            this.temp_freeitem = _.cloneDeep(arr_promotion);
            _.forEach(arr_promotion, function (value) {
                self.valueTree = _.union(self.valueTree, [value.id]);
            });
            this.showDialog = true;
        },
        searchOnTable() {
            var self = this;
            if (self.search != "") {
                _.forEach(this.temp_freeitem, function (o) {
                    let keyword = self.search.toLowerCase();
                    let code = o.code.toLowerCase();
                    let desc = o.desc.toLowerCase();
                    let c1 = code.search(keyword);
                    let c2 = desc.search(keyword);
                    if (c1 >= 0 || c2 >= 0) {
                        o.display = "show";
                    } else {
                        o.display = "";
                    }
                });
            } else {
                _.forEach(this.temp_freeitem, function (o) {
                    o.display = "show";
                });
            }
        },
        onsetIndex(index) {
            this.current_set = index;
        },
        loadOptions({
            action,
            searchQuery,
            callback
        }) {
            let self = this;
            let text = "";
            let type = "input";
            this.input_tree = searchQuery;
            if (searchQuery.split(" ").length <= 1) {
                text = searchQuery;
            } else {
                let splitText = searchQuery.split(" ");
                if (splitText.length < 1000) {
                    let texts = "";
                    splitText.forEach(function (value, key) {
                        texts += value + ",";
                    });
                    text = texts.substring(0, texts.length - 1);
                    type = "paste";
                } else {
                    this.dContent = "Data input text have Code more than 1000 Code.";
                    this.showSnackbar = true;
                    return false;
                }
            }
            
            // if (action === ASYNC_SEARCH && text.length >= 4 && text.length <= 8) {
            let input_search = self.$refs.productSearchTxt;
            let real_input = input_search[0].$el.querySelector('.vue-treeselect__input')
            if (action === ASYNC_SEARCH && text.length >= 4) {
                simulateAsyncOperation(() => {
                    // PromotionService.ProductTree(text)
                    PromotionService.ProductTreeFreeItem(text) //Change 04.10.2019 : ต้องการให้ product ทุกตัวออกมา ยกเว้นเงื่อนไขของ mst_config
                        .then(response => {
                            if(response.data == '' || response == '' || response == null) {
                                // alert when item incorrect
                                if(response.message !== undefined){
                                    self.alertProductLost = "";
                                    let number_msg = response.message.length;
                                    response.message.forEach(function (value, key) {
                                        self.alertProductLost += (key == (number_msg - 1)) ? value : value + ", ";
                                    });
                                    if(response.message.length > 0) {
                                        self.showDialogAlert = true;
                                    }
                                }
                                self.optionsTreeview =  []
                                callback(null, self.optionsTreeview)
                            } else {
                                if(response.data.id ==  text || (response.data.children !== undefined && response.data.children[0].code ==  text) 
                                        || (response.data.children === undefined && response.data.code == text)){
                                            self.optionsTreeview =  []
                                    self.optionsTreeview.push(response.data)

                                    self.completeProduct = response.data.length;
                                    self.alertProductLost = "";
                                    let length = response.message.length - 1;
                                    response.message.forEach(function (value, key) {
                                        self.alertProductLost += (key == length) ? value : value + ", ";
                                    });
                                    if(response.message.length > 0) {
                                        self.showDialogAlert = true;
                                        self.loadDialog = true;
                                    }
                                    
                                    callback(null, self.optionsTreeview)
                                }
                                
                                real_input.value = '' // clear input search product
                            }
                        })
                        .catch();
                });
            } else {
                this.dContent = "Data input text must be greater than 4 positions.";
                this.showSnackbar = true;
                return false;
            }

            var arr_id = text.split(/,/g);
            if (arr_id.length > 1) {
                simulateAsyncOperation(() => {
                    // PromotionService.ProductTree(text).then(response => {
                    PromotionService.ProductTreeFreeItem(text).then(response => { //Change 04.10.2019 : ต้องการให้ product ทุกตัวออกมา ยกเว้นเงื่อนไขของ mst_config
                        if(response.message.length > 0) {
                            self.alertProductLost = "";
                            let length = response.message.length - 1;
                            response.message.forEach(function (value, key) {
                                self.alertProductLost += (key == length) ? value : value + ", ";
                            });
                            self.showDialogAlert = true;
                            self.loadDialog = true;
                        }

                        if(response.data.length > 0){
                            self.optionsTreeview =  []
                            response.data.forEach(function (value, key) {
                                self.valueTree = _.union(self.valueTree, [value.id]);
                                self.openOnSelectTreeview(value)
                            })
                            self.optionsTreeview = response.data

                            self.completeProduct = response.data.length;
                            callback(null, self.optionsTreeview)
                            
                            real_input.value = '' // clear input search product
                        } else {
                            self.optionsTreeview =  []
                            callback(null, self.optionsTreeview)
                        }
                    }).catch();
                });
            } else {}
        },
        openOnSelectTreeview(node) {
            let self = this;
            if (node.children) {
                node.children.forEach(function (value, key) {
                    if (value.children) {
                        self.openOnSelectTreeview(value);
                    } else {
                        //Check ตัวแม่จาก level รองสุดท้าย
                        self.temp_freeitem = _.unionBy(
                            self.temp_freeitem,
                            [{
                                id: value.id,
                                code: value.code,
                                desc: value.title_th,
                                unit: value.selling_um_title,
                                unit_title: value.seu_title,
                                qty: "",
                                ratio: ["", ""],
                                display: "show",
                                ck_qty: "#fff",
                                ck_ratio: "#fff"
                            }],
                            "code"
                        );
                    }
                });
            } else {
                //Check last level
                self.temp_freeitem = _.unionBy(
                    self.temp_freeitem,
                    [{
                        id: node.id,
                        code: node.code,
                        desc: node.title_th,
                        unit: node.selling_um_title,
                        unit_title: node.seu_title,
                        qty: "",
                        ratio: ["", ""],
                        display: "show",
                        ck_qty: "#fff",
                        ck_ratio: "#fff"
                    }],
                    "code"
                );
            }
        },
        onDeSelectTreeview(node) {
            let self = this;
            if (node.children) {
                node.children.forEach(function (value, key) {
                    if (value.children) {
                        self.onDeSelectTreeview(value);
                    } else {
                        //Check ตัวแม่จาก level รองสุดท้าย
                        let index = self.temp_freeitem
                            .map(function (e) {
                                return e.code;
                            })
                            .indexOf(value.code);
                        if (index > -1) {
                            self.temp_freeitem.splice(index, 1);
                        }
                    }
                });
            } else {
                //Check last level
                let index = self.temp_freeitem
                    .map(function (e) {
                        return e.code;
                    })
                    .indexOf(node.code);
                self.temp_freeitem.splice(index, 1);
            }
        },
        ckConditions(item_free, type) {
            if (type == "qty") {
                if (item_free.qty.length > 0) {
                    item_free.ck_ratio = "#efefef";
                    item_free.ratio = ["", ""];
                } else {
                    item_free.ck_ratio = "";
                }
            } else if (type == "ratio") {
                if (item_free.ratio[0] > 0 || item_free.ratio[1] > 0) {
                    item_free.ck_qty = "#efefef";
                    item_free.qty = "";
                } else if (item_free.ratio[0] == 0 && item_free.ratio[1] == 0) {
                    item_free.ck_qty = "";
                }
            }
        },
        selectAll() {
            if (this.checkedProductsAll == false) {
                if (self.search == "") {
                    var re_diff = _.xor(this.temp_freeitem, []);
                    this.checkedProducts = re_diff;
                } else {
                    var temp_filter = _.filter(this.temp_freeitem, {
                        display: "show"
                    });
                    this.checkedProducts = temp_filter;
                }
            } else {
                this.checkedProducts = [];
            }
        },
        deleteProduct() {
            var self = this;
            var re_diff = _.difference(this.temp_freeitem, this.checkedProducts);
            _.forEach(self.checkedProducts, function (value) {
                self.valueTree.splice(self.valueTree.indexOf(value.id), 1);
            });
            this.temp_freeitem = re_diff;
            this.checkedProducts = [];
            this.checkedProductsAll = false;
        }
    }
};
/* eslint-disable */
</script>
<style lang="scss">
    /*span.multiselect__single:nth-child(2) {*/
    span.multiselect__single.promo-step-3:not(:nth-child(1)) {
        display:none;
    }
    .multiselect__tags span.promo-step-3.label_notselect{
        padding-left: 5px;
    }
    .multiselect__tags span.multiselect__single.promo-step-3,.multiselect__tags span.label_notselect{
        font-size: 13px !important;
        font-weight: 500;
        color: #3f51b5;
    }
#layout-default
  > div.mkt-main-content
  > div.mktops-create
  > div
  > div.md-gutter.mktops-stepper
  > div.md-card.main-content.md-theme-default
  > div.data-input-step {
  height: calc(100vh - 205px);
}
#layout-default
  > div.mkt-main-content
  > div.mktops-create
  > div
  > div.md-gutter.mktops-stepper
  > div.md-card.main-content.md-theme-default
  > div.step-content.mktops-step3-flex {
  margin-bottom: 15px;
}
#layout-default
  > div.mkt-main-content
  > div.mktops-create
  > div
  > div.md-gutter.mktops-stepper
  > div.md-card.main-content.md-theme-default
  > div.step-content.mktops-step3-flex
  > div.header-step
  > div.md-avatar {
  width: 36px;
  height: 36px;
  font-size: 18px;
}
#layout-default
  > div.mkt-main-content
  > div.mktops-create
  > div
  > div.md-gutter.mktops-stepper
  > div.md-card.main-content.md-theme-default
  > div.step-content.mktops-step3-flex
  > div.header-step
  > span {
  padding-top: 20px;

  font-size: 18px;

  font-weight: 500;

  font-family: "Roboto";

  padding-left: 13px;
}
#layout-default
  > div.mkt-main-content
  > div.mktops-create
  > div
  > div.md-gutter.mktops-stepper
  > div.md-card.main-content.md-theme-default
  > div.step-content.mktops-step3-flex
  > div.mktops-flex-end-center
  > div
  > button.mktops-add-condition-btn {
  margin-top: 24px;
}
#layout-default
  > div.mkt-main-content
  > div.mktops-create
  > div
  > div.md-gutter.mktops-stepper
  > div.md-card.main-content.md-theme-default
  > div.step-content.mktops-step3-flex
  > div.mktops-flex-end-center
  > div
  > button
  > div
  > div
  > span.add-condition-symbol {
  font-size: 15px;
}
#layout-default
  > div.mkt-main-content
  > div.mktops-create
  > div
  > div.md-gutter.mktops-stepper
  > div.md-card.main-content.md-theme-default
  > div.data-input-step
  > div
  > div
  > div
  > div
  > div
  > div.md-tabs-navigation.md-elevation-0
  > button {
  height: 33px;
}
#layout-default
  > div.mkt-main-content
  > div.mktops-create
  > div
  > div.md-gutter.mktops-stepper
  > div.md-card.main-content.md-theme-default
  > div.data-input-step
  > div
  > div
  > div
  > div
  > div
  > div.md-content.md-tabs-content.md-theme-default
  > div
  > div
  > div
  > div.md-layout-item.md-size-64
  > div.md-layout.md-gutter
  > div.md-layout-item.md-size-25 {
  min-width: unset;
  max-width: unset;

  padding-right: 15px;

  padding-left: 20px;
}
#layout-default
  > div.mkt-main-content
  > div.mktops-create
  > div
  > div.md-gutter.mktops-stepper
  > div.md-card.main-content.md-theme-default
  > div.data-input-step
  > div
  > div
  > div
  > div
  > div
  > div.md-content.md-tabs-content.md-theme-default
  > div
  > div
  > div
  > div.md-layout-item.md-size-64 {
  padding-right: unset;
  padding-left: unset;
}
#layout-default
  > div.mkt-main-content
  > div.mktops-create
  > div
  > div.md-gutter.mktops-stepper
  > div.md-card.main-content.md-theme-default
  > div.data-input-step
  > div
  > div
  > div
  > div
  > div
  > div.md-content.md-tabs-content.md-theme-default {
  height: calc(100vh - 240px) !important;
}
#layout-default
  > div.mkt-main-content
  > div.mktops-create
  > div
  > div.md-gutter.mktops-stepper
  > div.md-card.main-content.md-theme-default
  > div.data-input-step
  > div
  > div
  > div
  > div
  > div
  > div.md-content.md-tabs-content.md-theme-default
  > div
  > div
  > div
  > div.md-layout-item.md-size-35
  > button.add-customer {
  color: #3f51b5;
}
#layout-default
  > div.mkt-main-content
  > div.mktops-create
  > div
  > div.md-gutter.mktops-stepper
  > div.md-card.main-content.md-theme-default
  > div.data-input-step
  > div
  > div
  > div
  > div
  > div
  > div.md-content.md-tabs-content.md-theme-default
  > div
  > div
  > div
  > div.md-layout-item.md-size-35
  > div
  > div
  > div
  > div.multiselect__tags
  > div.multiselect__tags-wrap
  > span.multiselect__tag
  > i.multiselect__tag-icon {
  font-weight: unset;
  top: 2px;

  background: #3f51b5 !important;
}
#layout-default
  > div.mkt-main-content
  > div.mktops-create
  > div
  > div.md-gutter.mktops-stepper
  > div.md-card.main-content.md-theme-default
  > div.data-input-step
  > div
  > div
  > div
  > div
  > div
  > div.md-content.md-tabs-content.md-theme-default
  > div
  > div
  > div
  > div.md-layout-item.md-size-35
  > div
  > div
  > div
  > div.multiselect__tags
  > div.multiselect__tags-wrap
  > span.multiselect__tag
  > i.multiselect__tag-icon:after {
  color: #fff;

  font-size: 25px;

  font-family: "Roboto";
  padding-right: 10px;
}
#layout-default
  > div.mkt-main-content
  > div.mktops-create
  > div
  > div.md-gutter.mktops-stepper
  > div.md-card.main-content.md-theme-default
  > div.data-input-step
  > div
  > div
  > div
  > div
  > div
  > div.md-content.md-tabs-content.md-theme-default
  > div
  > div
  > div
  > div.md-layout-item.md-size-35
  > div
  > div
  > div
  > div.multiselect__content-wrapper
  > ul
  > li.multiselect__element
  > span.multiselect__option {
  white-space: unset;
}
#layout-default
  > div.mkt-main-content
  > div.mktops-create
  > div
  > div.md-gutter.mktops-stepper
  > div.md-card.main-content.md-theme-default
  > div.data-input-step
  > div
  > div
  > div
  > div
  > div
  > div.md-content.md-tabs-content.md-theme-default
  > div
  > div
  > div
  > div.md-layout-item.md-size-35
  > div
  > div
  > div
  > div.multiselect__content-wrapper
  > ul
  > li.multiselect__element
  > span.multiselect__option:after {
  background: #3f51b5 !important;
}
#layout-default
  > div.mkt-main-content
  > div.mktops-create
  > div
  > div.md-gutter.mktops-stepper
  > div.md-card.main-content.md-theme-default
  > div.data-input-step
  > div
  > div
  > div
  > div
  > div
  > div.md-content.md-tabs-content.md-theme-default
  > div
  > div
  > div
  > div.md-layout-item.md-size-35
  > div
  > div
  > div.md-chip {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
#layout-default
  > div.mkt-main-content
  > div.mktops-create
  > div
  > div.md-gutter.mktops-stepper
  > div.md-card.main-content.md-theme-default
  > div.data-input-step
  > div
  > div
  > div
  > div
  > div
  > div.md-content.md-tabs-content.md-theme-default
  > div
  > div
  > div
  > div.md-layout-item.md-size-35
  > div
  > div
  > div
  > div.multiselect__tags
  > input.multiselect__input {
  font-size: 14px !important;

  font-weight: 500;
  font-family: "Roboto";
}
#layout-default
  > div.mkt-main-content
  > div.mktops-create
  > div
  > div.md-gutter.mktops-stepper
  > div.md-card.main-content.md-theme-default
  > div.data-input-step
  > div
  > div
  > div
  > div
  > div
  > div.md-content.md-tabs-content.md-theme-default
  > div
  > div
  > div
  > div.md-layout-item.md-size-35
  > div
  > div
  > div
  > div.multiselect__tags
  > input.multiselect__input::-webkit-input-placeholder {
  color: #3f51b5;
}
#layout-default
  > div.mkt-main-content
  > div.mktops-create
  > div
  > div.md-gutter.mktops-stepper
  > div.md-card.main-content.md-theme-default
  > div.data-input-step
  > div
  > div
  > div
  > div
  > div
  > div.md-content.md-tabs-content.md-theme-default
  > div
  > div
  > div
  > div.md-layout-item.md-size-35
  > div
  > div
  > div
  > div.multiselect__tags
  > span
  > span.multiselect__single {
  font-size: 14px !important;

  font-weight: 500;
  font-family: "Roboto";

  color: #3f51b5;
}
#layout-default
  > div.mkt-main-content
  > div.mktops-create
  > div
  > div.md-gutter.mktops-stepper
  > div.md-card.main-content.md-theme-default
  > div.data-input-step
  > div
  > div
  > div
  > div
  > div
  > div.md-content.md-tabs-content.md-theme-default
  > div
  > div
  > div
  > div.md-layout-item.md-size-35
  > div
  > div
  > div
  > div.multiselect__tags
  > span.multiselect__single {
  font-size: 14px !important;

  font-weight: 500;
  font-family: "Roboto";

  color: #3f51b5;
}
#layout-default
  > div.mkt-main-content
  > div.mktops-create
  > div
  > div.md-gutter.mktops-stepper
  > div.md-card.main-content.md-theme-default
  > div.md-card-actions.mktops-action-button.md-alignment-right
  > button.md-button {
  font-family: "Roboto";
  font-size: 16px;
}
#layout-default
  > div.mkt-main-content
  > div.mktops-create
  > div.maincontent-create-3
  > div.md-gutter.mktops-stepper
  > div.md-card.main-content.md-theme-default
  > div.md-card-actions.mktops-action-button.md-alignment-right {
  padding-bottom: 25px;
  padding-right: 20px;
}
#md-dialog-freeitem {
  width: 80%;
  height: 80%;
  -webkit-transform: unset !important;
  transform: unset !important;
  top: 10% !important;
  left: 10% !important;
}
#md-dialog-freeitem > div > span.md-dialog-title {
  margin-bottom: unset;
}
#md-dialog-freeitem > div > div.md-dialog-actions > button {
  font-size: 16px;

  font-family: "Roboto";
}
#md-dialog-freeitem > div > div.md-dialog-actions {
  padding: 8px 24px 24px 24px;
}
#md-dialog-freeitem > div > div > div > span.span-item {
  font-size: 14px;

  font-family: "Roboto";

  color: #727272;
}
.number-of-items  {
    // font-weight: bold;
    text-align: right;
    margin-right: 20px;
    margin-top: 3px;
    
    > input {
       width: 15% !important;  
       text-align: right;
    }
}
.number-of-items > input,
#md-dialog-freeitem > div > div > div > div.filter-table > input {
  width: 100%;
  padding-left: 8px;
  padding-right: 8px;
  height: 36px;
  border: 1px solid #ddd;
  border-radius: 5px;
  background: #fff;
}
#md-dialog-freeitem > div > div > div > div.filter-table > input::placeholder {
  font-size: 14px;

  font-family: "Roboto";

  color: #a2a2a2;
}
.disabled-input {
    background-color: rgb(239, 239, 239) !important;
}
#table-freeitem-scroll {
  min-width: 100%;
  max-width: 100%;
  padding-right: 15px;
}
#divHeadFreeitem {
  width: 100%;
  display: -webkit-inline-box;
  font-size: 14px;

  font-family: "Roboto";

  font-weight: 500;
  padding-top: 15px;
  padding-bottom: 10px;
  color: #666666;
}
#divBodyFreeitem {
  font-size: 12px;

  font-family: "Roboto";
  color: #414141;

  width: 100%;
}
#divBodyFreeitem > div.row {
  width: 100%;
  display: -webkit-inline-box;
  padding-top: 5px;
  padding-bottom: 5px;
}
#dialogtable-freeitem-scroll {
  min-width: 100%;
  max-width: 100%;

  padding: 20px 24px;
}
// #dialogHeadFreeitem > div {
//     border: 1px solid red;
// }
#dialogHeadFreeitem {
  width: 99.5%;
  display: -webkit-inline-box;
  font-size: 14px;

  font-family: "Roboto";

  font-weight: 500;
  color: #666666;

  padding-top: 15px;
  padding-bottom: 10px;
}
#dialogBodyFreeitem {
  font-size: 12px;

  font-family: "Roboto";
  color: #414141;

  width: 100%;

  height: calc(80vmin - 290px);
  display: block;
  overflow-y: scroll;

    &::-webkit-scrollbar {
        height: 7px;
        width: 5px;
    }
}
// #dialogBodyFreeitem > div.row > div {
//     border: 1px solid red;
// }
#dialogBodyFreeitem > div.row {
  width: 100%;
  display: -webkit-inline-box;
  padding-top: 5px;
  padding-bottom: 5px;
}
#dialogBodyFreeitem > div > div > div.qty-table > input {
  width: 60%;
  height: 24px;
  border: 1px solid #ddd;
  border-radius: 5px;
  background: #fff;
}
#dialogBodyFreeitem > div > div > div > div > input {
  width: 60px;
  height: 24px;
  border: 1px solid #ddd;
  border-radius: 5px;
  background: #fff;
}

#dialogtable-freeitem-scroll {
  /* The checkbox-container */

  .checkbox-container {
    display: block;

    position: relative;

    padding-left: 35px;

    margin-bottom: 12px;

    cursor: pointer;

    font-size: 22px;

    -webkit-user-select: none;

    -moz-user-select: none;

    -ms-user-select: none;

    user-select: none;
  }

  /* Hide the browser's default checkbox */

  .checkbox-container input {
    position: absolute;

    opacity: 0;

    cursor: pointer;

    height: 0;

    width: 0;
  }

  /* Create a custom checkbox */

  .-checkbox-primary {
    position: absolute;

    top: 0;

    left: 0;

    height: 20px;

    width: 20px;

    background-color: #fff;

    border: 1px solid #a8a8a8;

    border-radius: 4px;
  }

  /* On mouse-over, add a grey background color */

  .checkbox-container:hover input ~ .-checkbox-primary {
    background-color: #ccc;
  }

  /* When the checkbox is checked, add a blue background */

  .checkbox-container input:checked ~ .-checkbox-primary {
    background-color: #3e51b5;

    border-color: #3e51b5;
  }

  /* Create the -checkbox-primary/indicator (hidden when not checked) */

  .-checkbox-primary:after {
    content: "";

    position: absolute;

    display: none;
  }

  /* Show the -checkbox-primary when checked */

  .checkbox-container input:checked ~ .-checkbox-primary:after {
    display: block;
  }

  /* Style the -checkbox-primary/indicator */

  .checkbox-container .-checkbox-primary:after {
    left: 6px;

    top: 1px;

    width: 5px;

    height: 13px;

    border: solid white;

    border-width: 0 2px 2px 0;

    -webkit-transform: rotate(45deg);

    -ms-transform: rotate(45deg);

    transform: rotate(45deg);
  }
}

#md-dialog-freeitem.md-theme-default :not(input):not(textarea)::-moz-selection {
  /* Code for Firefox */
  background-color: #3e51b5;
}

#md-dialog-freeitem.md-theme-default :not(input):not(textarea)::selection {
  background-color: #3e51b5;
}
</style>

<style lang="scss">
.promo-memo {
    width: 37%;
    z-index: 12;

    .md-dialog-title.md-title {
        font-size: 18px;
        margin-bottom: 5px;
        padding: 24px 25px 0;
    }

    .layout-dialog {
        padding: 10px 25px 5px 25px;
        font-family: kanit;
        color: #727272;

        ::placeholder {
            color: #BDBDBD;
            opacity: 1;
            font-size: 14px;
            font-family: lato;
        }

        textarea {
            width: 100% !important;
            min-width: 100%;
            max-width: 100%;
            min-height: 100px;
            max-height: 100px;
            font-size: 14px;
            font-family: kanit;
            margin-top: 6px;

            margin-top: 14px;
            padding-left: 8px;
            padding-right: 13.8px;
            border: 1px solid #ddd;
            border-radius: 5px;
            background: #fff;
        }
    }

    .-action {
        padding: 8px 20px 10px 24px;
        bottom: 0px;
        margin-right: auto;
        margin-left: auto;
        width: 100%;
        justify-content: flex-end;

        .-cancel .md-button-content {
            color: #727272;
        }

        .-save {
            color: #3f51b5 !important;
        }

        .-red {
            color: #F44336 !important;
        }

        .-green {
            color: #64a064 !important;
        }
    }
}

.sub-qty {
    width: 2px;
    margin: 20px 14px 20px 12px;
}

.alert-max {
    font-family: kanit;
    color: #727272;
    // margin-bottom: 8px;
}

.-inactive-product {
    // background-color: #ffd6d6;
    // color: #A8A8A8;
    color: red;
    font-style: italic;
}

.select-condotion-item {
    height: 36px;
    padding-right: 15px !important;
    padding-left: 0px !important;

    .md-field.box>.md-input.md-select-value,
    .md-field.box>.md-menu.md-select {
        font-size: 14px;
        width: 115.72px;
        height: 36px;
    }

    .md-field.md-field.box {
        margin-top: unset;
        margin-bottom: unset;
        padding: unset;
        min-height: 36px;
    }

    .md-field:after,
    .md-field:before {
        left: unset;
    }

    .md-field.box .md-input.md-input.md-select-value,
    .md-field.box label {
        font-size: 14px;
        padding-left: 12px;
        padding-top: 3px;
        color: #727272;
    }

    .md-field.box .md-select {
        background-color: #efefef;
        border-radius: 3px;
    }
}

.dialog-filter-product.-freeitem {
    width: 70%;
    max-width: 75% !important;
    top: 10% !important;
    left: 15% !important;

    // .check-condition {
    //     width: 100%;
    //     margin-top: 15px;
    //     font-family: kanit;
    //     font-size: 15px;
    //     // font-style: italic; 
    //     font-weight: 300;
    //     color: red;
    //     padding-left: 20px;
    // }
}
.bg-backdrop-promotion-loading {
    background: rgba(0, 0, 0, 0.35);
    width: 100%;
    height: 100%;
    position: absolute;
    z-index: 19;
    top: 0;
    left: 0;
}

.md-tabs-content {
    &::-webkit-scrollbar {
        height: 7px;
        width: 5px;
    }
}
</style>
